/// <reference path="HighchartsWrapper.js"/>
/// <reference path="ChartSetup/ChartSetupUIObj.js"/>
/// <reference path="ChartSetup/ChartSetupSelections.js" />

(function (sb) {
	sb.ChartLab = (sb.ChartLab || {});

	var OpenInChartLabPopupWindow;
	var openedChartLabArea;
	var openedChartLabElementGuid;
	var parts = ['Variables', 'Filters', 'Time periods', 'Change chart type', 'All settings', 'Weighting', 'Base limits', 'Optional features',
		'Hierarchical filters', 'Device limitation', 'Report format', 'Export format', 'Smart functions', 'Layout templates', 'Color templates',
		'Static filters', 'Favorites and sharing', 'Automatic table creation', 'Table key', 'Export options', 'Base'];
	var partIcons = ['icons/questions.png', 'icons/Filter.png', 'icons/datetime.png', 'icons/wand_graph.png', 'icons/settings.png'];
	var isLoaded = false;

	function open() {
		var settings = {
			title: openedChartLabArea,
			width: 890,
			height: 400,
			backgroundColor: '#fff',
			modal: true,
			preWrapSpace: false,
			buttons: [
				{
					text: 'Save',
					focused: true
				},
				{
					text: 'Cancel'
				}
			],
			beforeClose: function () {
				Storyboard.ChartLab.close();
			}
		};

		if (arguments.length > 0)
			$(settings).extend(true, settings, arguments[0]);

		OpenInChartLabPopupWindow = new DUIwindow2(settings);
		return OpenInChartLabPopupWindow;
	}

	function close() {
		var context = $('.DUI-WINDOW-BODY');

		switch (Storyboard.ChartLab.openedChartLabArea) {
			case Storyboard.ChartLab.parts[0]:
				$('#panels').prepend($('#variableSelection', context));
				break;
			case Storyboard.ChartLab.parts[1]:
				$('#panels').prepend($('#filterSelection', context));
				break;
			case Storyboard.ChartLab.parts[2]:
				$('#timeSelections').append($('.settingsFieldsetContent', context));
				break;
			case Storyboard.ChartLab.parts[3]:
				$('#hdSeriesSettings').prepend($('.SeriesTypeWrapper, .SeriesOptionWrapper:first', context));
				break;
			case Storyboard.ChartLab.parts[4]:
				var setupChart = $('#setupChart');
				setupChart.hide();
				if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()) {
					$('#setupHolder > div:first').after(setupChart);
				} else {
					$('#reportTabStripSpacer').after(setupChart);
				}
				break;
		}

		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(openedChartLabElementGuid);
		if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview())
			$(layoutElement).removeClass('layoutElementAdminFocused ui-selected');
	}

	function load(evt, guid) {
		Storyboard.ChartLab.openedChartLabArea = (evt.target == null) ? $(evt.srcElement).attr('title') : $(evt.target).attr('title');
		openedChartLabElementGuid = guid;

		var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(guid);
		var contentElement = Storyboard.LayoutDesigner.getLayoutElementItem(layoutElement);

		if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview())
			$(layoutElement).addClass('layoutElementAdminFocused ui-selected');

		Storyboard.DataGroupLogic.setupDataGroupEditing(contentElement, layoutElement);

		if (!isLoaded) {
			ChartSetupProxy.GetFilters(function (filters) {
				ChartSetupDataBinding.BindFilters(filters);
				ChartSetupDataBinding.BindHFilters();

				ChartSetupProxy.GetChartStyles(layoutElement, function (styles) {
					ChartSetupUI.bindChartStylesSelectElements();
					Storyboard.GuiEvents.DataGroupEdit.setChartStyleCacheWithGuid(styles, layoutElement.guid);
					Storyboard.DataGroupLogic.LoadDataGroupsForLayoutElementItem(contentElement, layoutElement, 'chartlab');
				});
			});
		} else {
			ChartSetupProxy.GetChartStyles(layoutElement, function (styles) {
				ChartSetupUI.bindChartStylesSelectElements();
				Storyboard.GuiEvents.DataGroupEdit.setChartStyleCacheWithGuid(styles, layoutElement.guid);
				Storyboard.DataGroupLogic.LoadDataGroupsForLayoutElementItem(contentElement, layoutElement, 'chartlab');
			});
		}

		loadChartSettings();
	}

	function chartSetupLoadedCallback(optionalSettings) {
		if (optionalSettings)
			Storyboard.ChartLab.optionalQuestions = optionalSettings.questions;

		var pagePart = '';

		var ofFloatingTimePeriodSelection = $('select[id="Floating time period"] > option:selected');
		var ofIntervalSelection = $('#Interval > option:selected');
		var ofMovingAverageSelection = $('select[id="Moving Average"] > option:selected');
		var ofFiltersSelection = $('#Filters > option:selected');

		// do some optional filter checks to hide chart settings
		if (ofIntervalSelection.length > 0)
			$('.hdIntervals').css('display', 'none');
		if (ofMovingAverageSelection.length > 0)
			$('.hdMovAvg').css('display', 'none');

		if (ofFloatingTimePeriodSelection.length > 0) {
			$('#ddlTimePeriod').css('display', 'none');
			$('.timePeriodSelections').css('display', 'none');
		}

		if (ofFiltersSelection.length > 0) {
			var selFilter = ofFiltersSelection.val().split('-');
			var filterBox = $('#filterSelection .settingItemBlock').not('.filterboxTemplate');
			filterBox.css('display', 'inline');
			filterBox = $(filterBox).eq(parseInt(selFilter[0], 10) - 1);
			filterBox.css('display', 'none');
		}
		// End optional filter checks
		switch (Storyboard.ChartLab.openedChartLabArea) {
			case Storyboard.ChartLab.parts[0]:
				open({ height: 335, width: 960, cssClass: "optional-chart-settings", title: '<h2>Variables</h2>' });
				pagePart = $('#variableSelection');
				$('#sbTextQAFiltering').text('Filtering');
				$('#sbTextQASelection').text('Selection');
				break;
			case Storyboard.ChartLab.parts[1]:
				open({ width: 960, height: 335, cssClass: "optional-chart-settings", title: '<h2>Filters</h2>' });
				pagePart = $('#filterSelection');
				break;
			case Storyboard.ChartLab.parts[2]:
				open({ height: 220, width: 480, cssClass: "optional-chart-settings", title: '<h2>Time Selections</h2>' });
				pagePart = $('#timeSelections .settingsFieldsetContent');
				break;
			case Storyboard.ChartLab.parts[3]:
				open({ height: 80, width: 300, cssClass: "optional-chart-settings", title: '<h2>Chart Type</h2>' });
				pagePart = $('.SeriesTypeWrapper, .SeriesOptionWrapper:first');
				break;
			case Storyboard.ChartLab.parts[4]:
				var setupChart = $('#setupChart');
				setupChart.show();
				ChartSetupUI.maketabs();
				ChartSetupUI.makeCollapsable();
				$("#tabholder").tabs("select", 0);
				open({ height: 'auto', cssClass: "optional-chart-settings-chart", title: '<h2>Chart</h2>' });
				pagePart = setupChart;
				break;
		}
		$('.ColorTextbox').DUIcolorPicker();
		$('.ColorTextboxNoTransparent').DUIcolorPicker({ 'transparent': false });
		$('.DUI-WINDOW-BODY').append(pagePart);
		$('#' + $('.DUI-WINDOW-OUTER .DUI-WINDOW-2').attr('id') + '_btn0').click(function (evt) {
			saveDUIWindowChartSettings(evt);
		});
		if ($('#filterBox').is(':visible')) {
			$('#filterBox .filterboxHeaderWrapper td').equalHeights();
		}
	}

    $.fn.equalHeights = function (px) {

	    var currentTallest = 0,
	        currentRowStart = 0,
	        rowDivs = new Array();

	    function setNewHeight(el, newHeight) {
	        el.data("originalHeight", (el.data("originalHeight") == undefined) ? (el.height()) : (el.data("originalHeight")));
	        el.height(newHeight);
	    }

	    function getOriginalHeight(el) {
	        return (el.data("originalHeight") == undefined) ? (el.height()) : (el.data("originalHeight"));
	    }

	    return $(this).filter(':visible').each(function () {
	        var $el = $(this);
	        var currentDiv;
	        var topPosition = $el.position().top;
	        
	        if (currentRowStart != topPosition) {
	            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) setNewHeight(rowDivs[currentDiv], currentTallest);

	            rowDivs.length = 0;
	            currentRowStart = topPosition;
	            currentTallest = getOriginalHeight($el);
                rowDivs.push($el);

	        } else {
	            rowDivs.push($el);
	            currentTallest = (currentTallest < getOriginalHeight($el)) ? (getOriginalHeight($el)) : (currentTallest);
	        }
	        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) setNewHeight(rowDivs[currentDiv], currentTallest);
	    });
	};

    function saveDUIWindowChartSettings(evt) {
        var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByGuid(openedChartLabElementGuid);
        var chartElem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.CHART, layoutElement);

        if (chartElem.guid !== Storyboard.GuiEvents.DataGroupEdit.getEditedChartElement().guid) {
            Storyboard.LayoutControls.showError('Could not save chart since it\'s assigned to another layout element');
            evt.stopImmediatePropagation();
        }
        else {
            if (!Storyboard.GuiEvents.DataGroupEdit) {
                evt.stopImmediatePropagation();
                return;
            }

            // if filters selection - apply selected filters to subgroups
            var applyFiltersToSubDgs = Storyboard.ChartLab.openedChartLabArea == Storyboard.ChartLab.parts[1];
            Storyboard.GuiEvents.DataGroupEdit.storeCurrentDataGroup(applyFiltersToSubDgs);
            var dataGroups = Storyboard.GuiEvents.DataGroupEdit.getDataGroups();

            if (Storyboard.GuiEvents.DataGroupEdit.validateDataGroups()) {
                var titleItem = Storyboard.GuiEvents.getHeaderDivForLayoutElement(layoutElement);
                var title = $(titleItem).text();
                var titleText = (title.length > 0) ? ' - ' + title + ': ' : ': ';
				var loadingBar = Storyboard.LayoutControls.showLoadingBar('Chartbox ' + layoutElement.layoutElementId + titleText + 'Saving and reloading updated chart...');
                ChartSetupDataCom.RHSaveDataGroups(dataGroups, chartElem.guid, function () {
                    Storyboard.LayoutControls.hideLoadingBar(loadingBar);
                    Storyboard.HighchartsWrapper.Helpers.setTheme(ChartSetupUIObj.GetChartStyles(), layoutElement);
                    var items = [layoutElement];
                    Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, layoutElement.guid);
                });
            }
        }
    }

    function checkPartAvailable(part, options) {
        var groupName = part.replace(/ /g, '_');

        if (options == null || (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview()))
            return false;

        for (var setting in options)
            if (options.hasOwnProperty(setting)) {

                if (options[setting].part == groupName) {
                    return (options[setting].flag > 0);
                }
            }
        return true;
    }

    function loadChartSettings(callback) {
    	if (isLoaded) {
    		if (callback) callback();
    		return;
    	}

		if (defaultChartRenderType != null && defaultChartRenderType != "")
			$("#dllGenerateByDecimals").val(defaultChartRenderType)

    	$('#seriesLayoutOptionsHelp').click(function () { ChartSetupUI.showSeriesLayoutInfo(); });
    	$('#gradientTypeOptionsHelp').click(function () { ChartSetupUI.showGradientTypeInfo(); });

		$('#sigTestHelp').click(function () { ChartSetupUI.showSigTestHelp(); });

		$('#sbTextMatchLogicHelp').click(function () { ChartSetupUI.showTextMatchLogicHelp(); });

        $("#chbShowQuestionCode").change(function () {
            var attributes = [];
            if ($("#chbShowQuestionCode").is(":checked"))
                attributes.push("code");
            attributes.push("questionText");
            HTMLHelpers.resetOptionsTexts($("#questionBox"), attributes, " - ");
		});

		$('#questionBox').change(function () {
			ChartSetupUI.limitLoopQnSelections();
    		ChartSetupUI.disableForSelectedQuestions();
            ChartSetupDataCom.FilterAnswers();
            ChartSetupUI.updateHeatMapLegendBox();
			ChartSetupUI.updateGroupingsAvailabillity('question', $(this));
			ChartSetupUI.showHideBaseInLoopedQnSettingsBox();
			ChartSetupUI.showHideRebaseSettingsBox();
			ChartSetupUI.disableSigTest($("#ddlCalculationType").val());
        });

        $("#chbShowAnswerId").change(function () {
            var attributes = [];
            if ($("#chbShowAnswerId").is(":checked"))
                attributes.push("rowNo");
            attributes.push("answerText");
            HTMLHelpers.resetOptionsTexts($("#answerbox"), attributes, " - ");
        });

        $("#answerbox").change(function () {
            DataGroupSelections.StoreSelectedAnswers(this);
            ChartSetupUI.updateHeatMapLegendBox();
            ChartSetupUI.updateGroupingsAvailabillity('answer', $(this));
        });

        $('#txtQuestion').keyup(function () { ChartSetupDataCom.FilterQuestions(); });
        $('#txtCorrelationQuestion').keyup(function () { ChartSetupDataCom.FilterCorrelationQuestions(); });
        $('#txtAnswer').keyup(function () { ChartSetupDataCom.FilterAnswers(); });

        $('#lbVS,#lbQB,#lbGQ').change(function () { ChartSetupDataCom.FilterQuestions(); });
        $('#ddlColorLogic').change(function () {
            ChartSetupUI.showHideColorPickerForSeries();
			ChartSetupUI.showHideLegendPosition();
			ChartSetupUI.showHideHFilterRuleColors();
			ChartSetupUI.showHideValueBasedColors();
        });
        $('#ddlGradientType').change(function () {
            $('#txtGradientMinValue').closest('span').hide();
            $('#txtGradientMaxValue').closest('span').hide();

            if ($(this).val() == Storyboard.Constants.GradientTypes.DynamicScale){
                $('#dynamicColorsTable span[id^="dynamicColorStopValuePercent_"]').show();
                $('#dynamicColorsTable input[id^="dynamicColorStopValue_"]').each(function () {
                    Helpers.setupNumericTextbox($(this), { minValue: 0, maxValue: 100 });
                });
            } else {
                $('#dynamicColorsTable span[id^="dynamicColorStopValuePercent_"]').hide();
                $('#dynamicColorsTable input[id^="dynamicColorStopValue_"]').each(function () {
                    Helpers.setupNumericTextbox($(this));
                });
            }   
		});
		$('#btnValueColoringInfo').click(function (event) {
			var html =
				'<p>When you activate the option to "Add coloring to value cells background", the system will override the existing background color of the cell. This modification occurs at the end of the table processing, affecting the background color of the table, formatting rules, and significance testing.</p>';

			new DUIwindow2({
				title: '<h2>Coloring by value</h2>',
				html: html,
				width: 680,
				buttons: [],
				afterShow: function () {
					$(event.currentTarget).addClass('dui-window-open-target');
				},
				afterClose: function () {
					setTimeout(function () { $(event.currentTarget).removeClass('dui-window-open-target'); }, 1);
				}
			});
		});

        $('#ddlCalculationType').change(function () {
            ChartSetupDataCom.FilterQuestions();
			DataGroupSelections.SetSelectedCalculationType(parseInt($(this).val()), parseInt($("#numericPercentileValue").val()));
            var calculationType = $("#ddlCalculationType").val() || "";

            var showSelected = $("#ddlShowBase").val() || "";
            var trimSelected = $("#ddlTrimLowBase").val() || "";
            var warnSelected = $("#ddlWarnLowBase").val() || "";
            var sigLimitSelected = $("#ddlSigTestLimitBase").val() || "";

			if (calculationType == '11') {
			    $('#numericPercentileValue').show();
			    $('#sbTextNumericPercentile').show();
			}
			else {
			    $('#numericPercentileValue').hide();
			    $('#sbTextNumericPercentile').hide();
			}

            if (calculationType == '1' || calculationType == '3' || calculationType == '7') {
                $('#hdBaseVariableOptions').show();
            }
            else {
                $('#ddlBaseVariable').val('0');
                $('#hdBaseVariableOptions').hide();
            }

            //hide old group data by option
            $('#hdCalculationOptions').hide();
            $('#ddlGroupDataBy').val('0');

			if ((calculationType == '8') || (calculationType == '9') || (calculationType == '10') || (calculationType == '11'))
			    $('#sbTextNumericNote').show();
			else
			    $('#sbTextNumericNote').hide();

            if (calculationType == "2" && $("#hdnExclAverage").val() == "1") {
                $('#ddlShowBase').empty().append($showBaseSelOptions);
                $('#ddlTrimLowBase').empty().append($trimLowBaseOtions);
                $('#ddlWarnLowBase').empty().append($warnLowBaseOptions);
                $('#ddlSigTestLimitBase').empty().append($sigTestLimitBaseOptions);
            }
            else {
                $('#ddlShowBase').empty().append($showBaseSelOptions.filter('.nonavg'));
                $('#ddlTrimLowBase').empty().append($trimLowBaseOtions.filter('.nonavg'));
                $('#ddlWarnLowBase').empty().append($warnLowBaseOptions.filter('.nonavg'));
                $('#ddlSigTestLimitBase').empty().append($sigTestLimitBaseOptions.filter('.nonavg'));
            }
            if ($("#ddlShowBase option[value='" + showSelected + "']").length > 0)
                $('#ddlShowBase').val(showSelected);
            else
                $('#ddlShowBase').val("0");

            if ($("#ddlTrimLowBase option[value='" + trimSelected + "']").length > 0)
                $('#ddlTrimLowBase').val(trimSelected);
            else
                $('#ddlTrimLowBase').val("1");

            if ($("#ddlWarnLowBase option[value='" + warnSelected + "']").length > 0)
                $('#ddlWarnLowBase').val(warnSelected);
            else
                $('#ddlWarnLowBase').val("1");

            if ($("#ddlSigTestLimitBase option[value='" + sigLimitSelected + "']").length > 0)
                $('#ddlSigTestLimitBase').val(sigLimitSelected);
            else
                $('#ddlSigTestLimitBase').val("1");

            ChartSetupUI.disableSeriesCompareOptions();
			ChartSetupUI.disableRespCountTooltip();
			ChartSetupUI.showHideRefDataPanel();
			ChartSetupUI.disableSigTest(calculationType);
			ChartSetupUI.showHideExcludeZeroFromTop();

            var calcTypes = Storyboard.Constants.CalculationTypes;
            var seriesTypes = Storyboard.Constants.SeriesTypes;
            var treeMapSupportedCalcTypes = [calcTypes.CATEGORICAL_PERCENT, calcTypes.NUMERIC_SUM, calcTypes.CATEGORICAL_COUNT];
            if (treeMapSupportedCalcTypes.indexOf(parseInt($(this).val(), 10)) === -1) {

                if ($("#ddlSeriesType").val() == seriesTypes.TREEMAP
                    || $("#ddlSeriesType").val() == seriesTypes.MARIMEKKO) {
                    $("#ddlSeriesType").val(seriesTypes.BAR);
                    $("#ddlSeriesType").trigger('change');
                }

                DataGroupSelections.HideOption($('#ddlSeriesType'), seriesTypes.TREEMAP);
                DataGroupSelections.HideOption($('#ddlSeriesType'), seriesTypes.MARIMEKKO);
			}
		});

		$('#rbRebasePercentageShare, #rbTotalBase, #rbFromOtherQuestion').change(function () {
			$('#rebaseVariableBox').toggle($('#rbFromOtherQuestion').is(':checked'));
		});

        $("#ddlAnalysisType").change(function () {
        	ChartSetupUI.configureSigTestType();
        });

        $("#ddlDataTestType").change(function () {
			ChartSetupUI.showHideSigTestVisualization();
			ChartSetupUI.showHideNoLetters();
        	$(".sigResultToShow").toggle($("#ddlAnalysisType").val() == "2" || $("#ddlDataTestType").val() == "1");
			$("#ddlSigTestHidePoints").closest(".settingItem").css("display", ($("#ddlAnalysisType").val() != "2" && $("#ddlDataTestType").val() == "1") ? "none" : "");
			ChartSetupUI.showHideSigTestValuesTooltip();
		});

		$("#chbUseTableCellGradient").change(function () {
			$("#dynamicColorsDiv").toggle($("#chbUseTableCellGradient").is(":checked"));
		});

        $("#ddlSigVisualizationType, #ddlSigTestHidePoints").change(function () {
        	ChartSetupUI.showHideSigTestVisualization();
		});

		$('#ddlSigResultToShow').change(function () {
			ChartSetupUI.showHideNoSymbolsSigTest();
		});

        $("#tblSigTestIcons .iconPreviewEl, #positiveIconContent, #negativeIconContent").bind("click", function () {
			$("#tblSigTestIcons .sigTestIconInEdit").removeClass("sigTestIconInEdit");
        	var row = $(this).closest("tr");
        	row.addClass("sigTestIconInEdit");
        	var iconId = row.find(".sigTestIconId").val() || 0;
        	var positive = row.find("#hidPositiveIconId").length > 0;

        	$("#iconPreviewDiv").css({
        		width: $("#txtSigTestIconWidth").val(),
        		height: $("#txtSigTestIconHeight").val()
        	});

        	IconShapeSetup.setupLibraryEditPanel(iconId, "#setupChart", positive ? IconShapeUI.defaultPositiveIcon : IconShapeUI.defaultNegativeIcon);
        });

        $("#txtSigTestIconWidth, #txtSigTestIconHeight").change(function () {
        	$("#negativeIconContent, #positiveIconContent")
				.css("width", $("#txtSigTestIconWidth").val() + "px")
				.css("height", $("#txtSigTestIconHeight").val() + "px");
        	IconShapeUI.updateIconShapeElementSize(null, $("#negativeIconContent"));
        	IconShapeUI.updateIconShapeElementSize(null, $("#positiveIconContent"));
        });

        $('#chkPercentile').change(function () {
			ChartSetupUI.onPercentileChecked();
			ChartSetupUI.showHideThresholdSettings();
			ChartSetupUI.disableRefData();
        });

        $('#ddlShowBase').change(function () { ChartSetupUI.hideBasePosition(); });
        $("#ddlTableBasePosition").change(function () { ChartSetupUI.updateBaseOrientation(); });
        $('#ddlSeriesOptions').change(function () {
            if ($('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.HEATMAP || $('#ddlSeriesType').val() == Storyboard.Constants.SeriesTypes.MARIMEKKO) {
                $('#chartstyle_series_dataLabels_align').parent().hide();
            } else {
                ChartSetupUI.disableForSeriesOptions($(this).val());
            }

            ChartSetupUI.showHideDataLabelPadding();
        });
        $('#ddlDataCompareType').change(function () { ChartSetupUI.updateSigTestOptions($(this).val()); });

        if ($('#ddlWeight option').length == 1)
            $('#ddlWeight').css("display", "none");
        else
            $('#ddlWeight').css("display", "");

		$("#ddlTimePeriod").change(function () {
			var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);
			ChartSetupUI.showHideDateSelections();
			ChartSetupUI.showTimeSettingsComparationOptions(selectedTimePeriod && $('#chkOptTimePeriod').is(':checked'));
		});

		$("#ddlTimePeriodSpan").change(function () {
			var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);
			ChartSetupUI.showTimeSettingsComparationOptions(selectedTimePeriod && $('#chkOptTimePeriod').is(':checked'));
		});

		$('#chkOptTimePeriod').bind('change', function () {
			var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);
			var interval = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.Interval);
			var movingAverage = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.MovingAverage);

			if ((selectedTimePeriod && $(this).is(':checked')) || (interval && $('#chkOptInterval').is(':checked')) || (movingAverage && $('#chkOptMovingAverage').is(':checked')))
				$('#lblTimePeriodInfo').show();
			else
				$('#lblTimePeriodInfo').hide();

			ChartSetupUI.setTimePeriodInfoMessage(selectedTimePeriod && $(this).is(':checked'), interval && $('#chkOptInterval').is(':checked'), movingAverage && $('#chkOptMovingAverage').is(':checked'));
			ChartSetupUI.showTimeSettingsComparationOptions(selectedTimePeriod && $(this).is(':checked'));
		});

		$('#chkOptInterval').bind('change', function () {
			var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);
			var interval = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.Interval);
			var movingAverage = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.MovingAverage);

			if ((selectedTimePeriod && $('#chkOptTimePeriod').is(':checked')) || (interval && $(this).is(':checked')) || (movingAverage && $('#chkOptMovingAverage').is(':checked')))
				$('#lblTimePeriodInfo').show();
			else
				$('#lblTimePeriodInfo').hide();

			ChartSetupUI.setTimePeriodInfoMessage(selectedTimePeriod && $('#chkOptTimePeriod').is(':checked'), interval && $(this).is(':checked'), movingAverage && $('#chkOptMovingAverage').is(':checked'));
			ChartSetupUI.showTimeSettingsComparationOptions(selectedTimePeriod && $('#chkOptTimePeriod').is(':checked'));
		});

		$('#chkOptMovingAverage').bind('change', function () {
			var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);
			var interval = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.Interval);
			var movingAverage = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.MovingAverage);

			if ((selectedTimePeriod && $('#chkOptTimePeriod').is(':checked')) || (interval && $('#chkOptInterval').is(':checked')) || (movingAverage && $(this).is(':checked')))
				$('#lblTimePeriodInfo').show();
			else
				$('#lblTimePeriodInfo').hide();

			ChartSetupUI.setTimePeriodInfoMessage(selectedTimePeriod && $('#chkOptTimePeriod').is(':checked'), interval && $('#chkOptInterval').is(':checked'), movingAverage && $(this).is(':checked'));
			ChartSetupUI.showTimeSettingsComparationOptions(selectedTimePeriod && $('#chkOptTimePeriod').is(':checked'));
		});

		$('#chkOptFiltersCheckAll').bind('change', function () {
			var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);
			var interval = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.Interval);
			var movingAverage = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.MovingAverage);

			if ((selectedTimePeriod && $(this).is(':checked')) || (interval && $(this).is(':checked')) || (movingAverage && $(this).is(':checked')))
				$('#lblTimePeriodInfo').show();
			else
				$('#lblTimePeriodInfo').hide();

			ChartSetupUI.setTimePeriodInfoMessage(selectedTimePeriod && $(this).is(':checked'), interval && $(this).is(':checked'), movingAverage && $(this).is(':checked'));
			ChartSetupUI.showTimeSettingsComparationOptions(selectedTimePeriod && $(this).is(':checked'));
		});

		$('#btnAdvTimeComparisons').bind('click', function () {
			if ($("#btnAdvTimeComparisons i").hasClass("DUI-icon-a-bottom")) {
				$("#btnAdvTimeComparisons i").removeClass('DUI-icon-a-bottom').addClass('DUI-icon-a-top');
				$('#advTimeComparisonsSection').show();
			}
			else {
				$("#btnAdvTimeComparisons i").removeClass('DUI-icon-a-top').addClass('DUI-icon-a-bottom');
				$('#advTimeComparisonsSection').hide();
            }
		});

        $("#ddlMovingAverage").change(function () {
        	var selectedMa = $("#ddlMovingAverage").val();
            $(".hdShowMovingAverage").toggle(selectedMa > 1);
            $("label[for='chbShowPreviousIntervals']").text("Show first " + (selectedMa - 1) + " interval" + (selectedMa > 2 ? "s" : ""));
        });

        $("#chbEnableTooltip").change(function () {
        	if ($(this).is(':checked'))
        		$('.tooltipItems').removeAttr('disabled');
        	else
        		$('.tooltipItems').attr('disabled', 'disabled');
        });

        $('#chkAutoGrid').bind('change', function () {
            if ($(this).is(':checked'))
                $('#txtGridInterval').attr('disabled', 'disabled');
            else
                $('#txtGridInterval').removeAttr('disabled');
        });

        $('#chkUseWeight').bind('change', function () {
            if ($(this).is(':checked')) {
                $('#ddlBaseSizeType').attr('disabled', false);
            }
			else {
				var analysisType = $('#ddlAnalysisType').val();
                $('#ddlBaseSizeType').val(analysisType == 3 ? "3" : "2");
                $('#ddlBaseSizeType').attr('disabled', 'disabled');
            }
		});

		$('#chbUseLoopedResponses').bind('change', function () {
			if ($(this).is(':checked')) 
				$('#chbUseRespondents').removeAttr("checked");
			else 
				$('#chbUseRespondents').attr("checked", "checked");

			ChartSetupUI.showHideRebaseSettingsBox();
		});

		$('#chbUseRespondents').bind('change', function () {
			if ($(this).is(':checked'))
				$('#chbUseLoopedResponses').removeAttr("checked");
			else
				$('#chbUseLoopedResponses').attr("checked", "checked");

			ChartSetupUI.showHideRebaseSettingsBox();
		});

		$('#chbIncludeTheSamePeriodOfPreviousYears').bind('change', function () {
			if ($(this).is(':checked'))
				$('#chbIncludePreviousPeriods').removeAttr("checked");
		});

		$('#chbIncludePreviousPeriods').bind('change', function () {
			if ($(this).is(':checked'))
				$('#chbIncludeTheSamePeriodOfPreviousYears').removeAttr("checked");
		});

        $("#chkUseMainFormattingRules").bind("change", function () { ChartSetupUI.hideFormatRulesBtn(); });

        $('#chbMatchseries, #chbMatchSeriesRows').bind('change', function () {
            ChartSetupUI.disableMatchOnText();
        });

        $("#btnMoveToLegend, #btnMoveToAxis").click(function () { ChartSetupUI.moveItems(this) });
		$("#chbNestCompareFilters").bind('change', function () { ChartSetupUI.nestCompareFilters(); ChartSetupUI.updateCompareFilterWeightSelections(); });
        $("#chbHFilterCompare").bind('change', function () { ChartSetupUI.addHFilterToGrouping($(this).attr("checked")) });

        $("#btnAddHFilterToComparison").bind("click", function () { ChartSetupUI.addHFilterToComparison(); });
        $("#hFilterComparisonRules").bind("change", function () { ChartSetupUI.comparisonGroupChanged(); });
		$("#chkSignificance").bind("change", function () {
			ChartSetupUI.disableSigTests();
			ChartSetupUI.disableRefData();
		});
        $("#chbTrimLowBase").bind("change", function () { ChartSetupUI.disableHideLowBase(); });
        $("#chbTrimLowResult").bind("change", function () { ChartSetupUI.disableHideLowResult(); });
		$("#ddlTrimLowResultObject").bind("change", function () { ChartSetupUI.disableHideLowResultBaseType(); });
		$("#ddlWarnLimits").bind("change", function () { ChartSetupUI.toggleCustomWarnLimit(); });
		$("#ddlHideLimits").bind("change", function () { ChartSetupUI.toggleCustomHideLimit(); });
        $("#chbAutoRadius").bind("change", function () { ChartSetupUI.disableCustomRadius(); });
        $("#chbAutoGradient").bind("change", function () { ChartSetupUI.disableCustomGradient(); });
        $("#chbWarnLowBase").bind("change", function () { ChartSetupUI.disableWarnLowBase(); });
        $('#chbThreshold').bind('change', function () {
            ChartSetupUI.showHideThresholdSettings();
        });
        $("#chkUseWeight").bind("change", function () {
            ChartSetupUI.disableWeightVariable(this);
		});
		$("#chbEnableMeanValueSeries").bind("change", function () { ChartSetupUI.disableMeanSeries(); ChartSetupUI.disableRunTopAfterMeanAggregate(); });
		$("#ddlMeanSeriesSubgroup").bind("change", function () { ChartSetupUI.disableMeanSeriesColor(); ChartSetupUI.disableMeanSeriesSubgroup(); });
		$("#chbHideOriginalSeries").bind("change", function () {
			ChartSetupUI.checkHideOriginal($(this).is(':checked'));
		});
        $("#ddlMeanValueOrientation").bind("change", function () { ChartSetupUI.disableMeanSeriesColor(); ChartSetupUI.disableMeanSeriesSubgroup(); });
        $("#chbUseMainOptFilterSettings").bind("change", function () { ChartSetupUI.hideOptionalFilters(); });
        $("#chbShowOnlyBenchmarks").bind("change", function () { ChartSetupUI.hideForBenchmarkOptions(); });
        $("#chbSortBenchmarks").bind("change", function () { ChartSetupUI.enableBenchmarkSorting(); });
		$("#chkEnableBenchmark").bind("change", function () {
			ChartSetupUI.enableBenchmark();
			ChartSetupUI.enableDisableTopSeriesSettings();
			ChartSetupUI.disableRefData();
		});
		$("#ddlBenchmarkAxis").bind("change", function () {
			ChartSetupUI.enableDisableTopSeriesSettings();
		});
		$('#ddlBenchmarkMatchBy').bind('change', function () { ChartSetupUI.showHideBenchmarkTextMatch(); });
		$('#ddlSigTextMatchBy').bind('change', function () { ChartSetupUI.showHideSigTextMatch(); });

		$("#chbEnableAggregatedSeries").bind("change", function () {
			ChartSetupUI.disableAggregatedSeries();
			ChartSetupUI.disableRunTopAfterMeanAggregate();
			ChartSetupUI.disableRefData();
		});
		$("#ddlAggregatedSeriesSubgroup").bind("change", function () { ChartSetupUI.disableAggregatedSeriesColor(); ChartSetupUI.disableAggregatedSeriesSubgroup(); });
		$("#chbAggrHideOriginalSeries").bind("change", function () {
			ChartSetupUI.checkHideOriginal($(this).is(':checked'));
		});
		$("#ddlAggrSeriesOrientation").bind("change", function () { ChartSetupUI.disableAggregatedSeriesColor(); ChartSetupUI.disableAggregatedSeriesSubgroup(); });

		$("#chkEnableRanking").bind("change", function () {
			ChartSetupUI.enableRanking();
			ChartSetupUI.enableDisableTopSeriesSettings();
		});
        $("#chkRankOnOptionalFilter").bind("change", function () { ChartSetupUI.enableRankingOptionalFilter(); });
		$("#ddlRankingAxis").bind("change", function () {
			ChartSetupUI.updateRankingObjects();
			ChartSetupUI.enableDisableTopSeriesSettings();
		});
		$("#chkShowOnlyRanking").bind("change", function () { ChartSetupUI.enableRankingPosition(); });
		$('#chkShowRankTotalSuffix').bind('change', function () { ChartSetupUI.enableRankingSuffix(); });

		$('#ddlShowTopSeriesOrientation').bind('change', function () { ChartSetupUI.showHideTopSeriesRangeOptions(); });

		$('#chbEnableReferenceData').bind('change', function () { ChartSetupUI.onRefDataEnabled(); });
		$('#fsRefDataSettings input.refDataResult').bind('click', function () { ChartSetupUI.onRefDataResultTypeChanged($(this).is(':checked') ? $(this).val() : 0); });
		$('#chbSortOnRefData').bind('change', function () { ChartSetupUI.onRefDataSortChanged(); });

        $("#chkEnableCustomColumnHeaders, #chkEnableCustomRowHeaders").bind("change", function () { ChartSetupUI.enableCustomHeaders(); });
        $("#btnAddColumnHeader, #btnAddRowHeader").bind("click", function () { ChartSetupUI.addNewCustomHeader($(this).attr("data-axis")); });

        $("#rt_cell_autowidth").bind("change", function () {
            ChartSetupUI.disableColumnWidth(this);
        });

        $("#rt_cell_autoheight").bind("change", function () {
            ChartSetupUI.disableRowHeight(this);
		});

		$("#chartstyle_series_marker_enabled").bind("change", function () {
			Storyboard.LayoutDesigner.UserEvents.showMarkersMessage(ChartSetupDataBinding.GetBoundContentType() == Storyboard.Constants.itemTypes.CHART);
		});

        $("#chbUseSecondaryAxis").bind("change", function () {
            DataGroupSelections.ToggleAxisPanel($(this).is(':checked'), $(this).is(':checked'));
		});
		$('#chbTransformIntoPolar').bind('change', function () { ChartSetupUI.showHideExportAsImage(); });
        $("#ddlSeriesType").bind('change', function () {
			var seriesType = parseInt($("#ddlSeriesType option:selected").val(), 10);
			var prevousType = $("#ddlSeriesType").attr('data-selected-type');
			$("#ddlSeriesType").attr('data-selected-type', seriesType);
            var dataGroup = ChartSetupDataBinding.GetBoundDataGroup();
            var contentType = ChartSetupDataBinding.GetBoundContentType();
			DataGroupSelections.HideGuiElementsByType(seriesType, dataGroup, contentType);
            HTMLHelpers.setSelectedValues("#ddlSeriesType", seriesType);
			ChartSetupUI.hideBasePosition();
			ChartSetupUI.toggleCustomWarnLimit();
			ChartSetupUI.toggleCustomHideLimit(); 
            ChartSetupUI.disableWarnLowBase();
            ChartSetupUI.disableHideLowBase();
			ChartSetupUI.disableHideLowResult();
			ChartSetupUI.showHideExportAsImage(seriesType, dataGroup, contentType);
            // for gauge type - Question and Answer must always be in legend
            if (seriesType == Storyboard.Constants.SeriesTypes.GAUGE || seriesType == Storyboard.Constants.SeriesTypes.SOLIDGAUGE) {
                var groupTypes = Storyboard.Constants.GroupTypes;
                var consts = Storyboard.Constants;

                ChartSetupDataBinding.DeleteGroupingByValue(groupTypes.ANSWER_VAL);
                ChartSetupDataBinding.DeleteGroupingByValue(groupTypes.QUESTION_VAL);
                ChartSetupDataBinding.DeleteGroupingByValue(groupTypes.TIMEPERIOD_VAL);

                var questionGrouping = groupTypes.getGroupItem(groupTypes.QUESTION_VAL, consts.Axis.legend, 0, '');
                ChartSetupDataBinding.EnsureGroupingExists(questionGrouping);
                if (consts.CalculationTypes.isAnswerBased($('#ddlCalculationType').val())) {
                    var answerGrouping = groupTypes.getGroupItem(groupTypes.ANSWER_VAL, consts.Axis.legend, 1, '');
                    ChartSetupDataBinding.EnsureGroupingExists(answerGrouping);
                }
                var timePeriodGrouping = groupTypes.getGroupItem(consts.GroupTypes.TIMEPERIOD_VAL, consts.Axis.legend, 2, '');
                ChartSetupDataBinding.EnsureGroupingExists(timePeriodGrouping);

                DataGroupSelections.SetDataGroupingSelections(dataGroup);

                if (seriesType == Storyboard.Constants.SeriesTypes.SOLIDGAUGE)
                	DataGroupSelections.SetChartStyles([{ settingKey: "pane_background_backgroundColor", settingValue: "#d8d8d8" }]);
            }
            
            if (seriesType != Storyboard.Constants.SeriesTypes.SOLIDGAUGE)
                DataGroupSelections.SetChartStyles([{ settingKey: "pane_background_backgroundColor", settingValue: "rgba(255, 255, 255, 0.001)" }]);

			ChartSetupUI.disableForSeriesType($(this).val(), prevousType);
			Storyboard.LayoutDesigner.UserEvents.showMarkersMessage(contentType == Storyboard.Constants.itemTypes.CHART);
        });

        $('#ddlGroupDataBy').change(function () {
            if ($('#ddlGroupDataBy option:selected').val() !== '0') {
                $('#lblGroupDataByInfo').show();
            } else {
                $('#lblGroupDataByInfo').hide();
            }
        });

        $('#chkPercentile').bind('change', function () {
            if ($(this).is(':checked')) {
                $('#percentilePanel').children().show();
            } else {
                $('#percentilePanel').children().not(':first').not(':nth-child(2)').hide();
            }
        });

        $("#ddlShowTopSeriesMode").bind("change", function () {
			$("label[for='chbExcelExportAllSeries']").text("Include all " + ($("#ddlShowTopSeriesMode").val() == 1 ? "rows" : "columns") + " into Excel file");
			ChartSetupUI.enableDisableTopSeriesSettings();
        });

        $("#chbAllowExcelExport, #chbShowTopSeries").bind('change', function () {
			ChartSetupUI.showHideExcelExportAllRows();
			ChartSetupUI.enableDisableTopSeriesSettings();
		});

		$('#chbScatterMeanLines').bind('change', function () {
			ChartSetupUI.showHideScatterMeanLineSettings();
		});

		$('#chbScatterMeanQuadrants').bind('change', function () {
			ChartSetupUI.showHideScatterMeanQuadrantSettings();
		});

		$('input[type="radio"][name="scatterLabelPos"]').bind('change', function () {
			ChartSetupUI.showHideShortTextTypeSettings();
		});

		$("#ddlScatterShortTextType").bind("change", function () {
			ChartSetupUI.showHideShortTextInputs();
		});

		Helpers.setupNumericTextbox($("#txtScatterPointOpacity"));
		$("#txtScatterPointOpacity").bind("change", function () {
			var opacity = parseInt($(this).val(), 10);
			opacity = (isNaN(opacity) ? 100 : Math.max(0, Math.min(100, opacity)));
			$(this).val(opacity);
		});

        if (callback) callback();

        var custFormat = 'dd/mm/yy';
        if (custDateFormatDP != null && custDateFormatDP != "")
            custFormat = custDateFormatDP;

		$('#setupChart .dateInput').datepicker('destroy');
		$('#setupChart .dateInput').datepicker({
            dateFormat: custFormat,
            showWeek: true,
            firstDay: 1,
            changeMonth: true,
            changeYear: true
        });

        var strToDate = function (str) {
            var arr = str.split(',');
            return new Date(arr[0], arr[1], arr[2]);
        };

        $('#txtStartDate').datepicker('setDate', strToDate($('#txtStartDate').attr('defaultdate')));
        $('#txtStopDate').datepicker('setDate', strToDate($('#txtStopDate').attr('defaultdate')));

        $('#txtStartDate').datepicker('option', 'defaultDate', strToDate($('#txtStartDate').attr('defaultdate')));
        $('#txtStopDate').datepicker('option', 'defaultDate', strToDate($('#txtStopDate').attr('defaultdate')));

        Helpers.setupNumericTextbox('#txtMinScale');
        Helpers.setupNumericTextbox('#txtMaxScale');
        Helpers.setupNumericTextbox('#txtNoofDecimals', { minValue: 0, maxValue: 15 });
        Helpers.setupNumericTextbox('#txtShowTopSeries', { allowDecimals: false });
		Helpers.setupNumericTextbox('#txtShowTopSeriesTo', { allowDecimals: false });
        Helpers.setupNumericTextbox('#txtGridInterval');
        Helpers.setupNumericTextbox('#startPercentile');
        Helpers.setupNumericTextbox('#txtTrimLowResultValue');
		Helpers.setupNumericTextbox('#numericPercentileValue');
		Helpers.setupNumericTextbox('#txtRefDataPercentile', { minValue: 0, maxValue: 100 });	
		Helpers.setupNumericTextbox('#chartstyle_series_pointWidth', true);
		Helpers.setupNumericTextbox('#txtNumberOfPreviousYears', { minValue: 1, maxValue: 50, allowDecimals: false });
		Helpers.setupNumericTextbox('#txtNumberOfPreviousPeriods', { minValue: 1, maxValue: 50, allowDecimals: false });
		Helpers.setupNumericTextbox('#txtTimePeriod', { minValue: 1, allowDecimals: false });
        isLoaded = true;
    }

    sb.ChartLab.open = open;
    sb.ChartLab.close = close;
    sb.ChartLab.load = load;
    sb.ChartLab.parts = parts;
    sb.ChartLab.partIcons = partIcons;
    sb.ChartLab.openedChartLabArea = openedChartLabArea;
    sb.ChartLab.checkPartAvailable = checkPartAvailable;
    sb.ChartLab.chartSetupLoadedCallback = chartSetupLoadedCallback;
    sb.ChartLab.saveDUIWindowChartSettings = saveDUIWindowChartSettings;
    sb.ChartLab.loadChartSettings = loadChartSettings;

})(window.Storyboard = (window.Storyboard || {}));


window.addNewPercentileRow = function () {
    var row = $('.percentileRowTemplate').first().clone();
    row.css('display', '');
    row.addClass('percentileRow');
    row.removeClass('percentileRowTemplate');
    var table = $('.percentileRowTemplate').parent();
    row.find('.colourPercentile').DUIcolorPicker({ layout: 'template' });

    table.append(row);

};

window.removeCurrentPercentileRow = function () {
    $(this).parents("tr").remove();
};

$.extend(Storyboard.ChartLab, function () {

    var settings = null;
    var checkSetupIntervalID = null;
    var chartMode = null;
    var optionalSettings = null;
    var elementItem = null;

	function loadSettings(evt, isChartLevelSetup, contentElement) {
        chartMode = typeof isChartLevelSetup !== "undefined" ? isChartLevelSetup : false;
        elementItem = typeof contentElement !== "undefined" ? contentElement : null;

        var data = {
            reportId: Helpers.getReportID(),
            chartMode: chartMode,
            layoutElementItem: elementItem
        };

        Helpers.perfJSonCall({
            method: "LoadChartLabSettings",
            service: 'chartsetup',
            data: data,
            successCallback: function (settings) {
                Storyboard.ChartLab.Setup.settings = settings;
                Storyboard.ChartLab.Setup.load();
            },
            failedCallback: function (failed) {
                evt.stopImmediatePropagation();
                Storyboard.LayoutControls.showMessage(locale.get('Unable to load Chart lab settings'));
            },
            fixCasing: false
        });
    }

    function load() {
        var window = Storyboard.ChartLab.open({ title: 'Optional chart settings', width: 650, height: 'auto' });

        var enableChartLabChecked = '';
        if (Storyboard.ChartLab.Setup.settings && Storyboard.ChartLab.Setup.settings.length > 0 && Storyboard.ChartLab.Setup.settings[0].part == null && Storyboard.ChartLab.Setup.settings[0].flag == null && Storyboard.ChartLab.Setup.settings[0].disabled == false)
            enableChartLabChecked = ' checked = "checked"';

        var html = [];
        html.push('<div class="DUIToolbar enableChartLab">');
        html.push('<div class="DUI-custom-checkbox">');
        html.push('<input type="checkbox" name="chkEnableChartLab" id="chkEnableChartLab"' + enableChartLabChecked + ' onchange="Storyboard.ChartLab.Setup.disabledOrEnableAllParts();" />');
        html.push('<label for="chkEnableChartLab">' + locale.get('Enable Optional Chart Settings') + '</label>');
        if (chartMode)
            html.push('<label style="float: right; font-weight: normal; font-size: 11px">Editing chart box ' + elementItem.layoutElementId + '</label>');
        html.push('<div class="floatClear"></div>');
        html.push('</div>');
        html.push('</div>');
        $('.DUI-WINDOW-BODY').append(html.join(''));

        html = [];
        html.push('<div id="ChartLabSetup">');

        var chartParts = [];
        for (var i = 0; i <= 4; i++)
        	chartParts.push(Storyboard.ChartLab.parts[i]);

        for (var part in chartParts) {
        	if (Storyboard.ChartLab.parts.hasOwnProperty(part))
        		html.push(createPart(Storyboard.ChartLab.parts[part]));
        }

        html.push('</div>');
        $('.DUI-WINDOW-BODY').append(html.join(''));

        $('.DUI-WINDOW-BUTTONS > INPUT:eq(0)')
            .click(function (evt) {
                Storyboard.ChartLab.Setup.save(evt, window);
			});

        $('.ChartLabSetupPart :button').click(function (evt) {
            Storyboard.ChartLab.Setup.loadCustomSettings(evt);
        });

        $('.DUI-WINDOW-BUTTONS > INPUT:eq(1)').click(function (evt) {
            clearInterval(Storyboard.ChartLab.Setup.checkSetupIntervalID);
            window.Close();
        });

        checkSetupIntervalID = setInterval('Storyboard.ChartLab.Setup.check()', 200);
        hideShowSelectButtons();
        $('.ChartLabSetupPart [type="radio"]').click(function () {
            var part = $(this).closest('.ChartLabSetupPart');
            
            if ($(part).find('[type="radio"][value="2"]').is(':checked')) {
                $(part).find('[type="button"]').data('isCaller', true);
                $(part).find('[type="button"]').click();
            } else {
                hideShowButton(part);
            }
		});

    }

    function createPart(part) {
        var html = [];
        var lastPart = Storyboard.ChartLab.parts[4];
        var controlSettings = ['None', 'All', 'Select'];
        if (chartMode)
            controlSettings.push('Report settings');

        html.push('<div class="ChartLabSetupPart size-1-5 ' + (part === lastPart ? 'size-last' : '') + '">');
        html.push('<h3 class="settingsGroupTitle">' + part + '</h3>');

        // All setup for enumeration with a 3rd option with setting value = 1 to enable detailed control of settings, but skip that for now
        for (var index = 0; index < controlSettings.length; index++) {
            if (index > 1 && part == Storyboard.ChartLab.parts[4]) // don't add Select and Report settings for All Settings for now
                continue;

            var groupName = part.replace(/ /g, '_');
            var btnName = 'rd' + groupName + index;
            var isEnabled = $('#chkEnableChartLab').is(':checked') ? '' : ' disabled="disabled"';
            var isChecked = '';
            var settings = Storyboard.ChartLab.Setup.settings;

            // set default 'None' checked
            if ((!settings || !settings[0]) && index == 0)
                isChecked = ' checked="checked"';
            else {
                for (var setting in settings)
                    if (settings.hasOwnProperty(setting)) {

                        if (settings[setting].part == groupName && settings[setting].flag == index) {
                            isChecked = ' checked="checked"';
                            break;
                        }
                    }
            }

            html.push('<div class="floatClear">');
            html.push('<input type="radio" name="' + groupName + '" id="' + btnName + '" value="' + index + '"' + isChecked + isEnabled + ' />');
            if (index != Storyboard.Constants.OptionalChartSettingsFlags.Select) {
                html.push('<label for="' + btnName + '">' + controlSettings[index]+ '</label>');
            }
            else {
                html.push('<label for="' + btnName + '">' + controlSettings[index] + '</label>');
                html.push('<input id="btn_' + groupName + '" type="button" value="Select..." class="DUIButton" />');
            }
            html.push('</div>');
        }
        html.push('</div>');
        return html.join('');
    }

    function disabledOrEnableAllParts() {
        var enable = $('#chkEnableChartLab').is(':checked');
        if (enable) {
            $('.ChartLabSetupPart input:radio, .ChartLabSetupPart input[type="button"]').removeAttr('disabled');
        } else {
            $('.ChartLabSetupPart input:radio, .ChartLabSetupPart input[type="button"]').attr('disabled', 'disabled');
        }
    }

    function save(evt, window) {
        evt.preventDefault();
		
        var chartParts = []; // starting 5 we have cross table stuff, ignore it
        for (var i = 0; i <= 4; i++)
        	chartParts.push(Storyboard.ChartLab.parts[i]);

        var parts = [];
        var enableChartlab = $('#chkEnableChartLab').is(':checked');
        for (var part in chartParts)
            if (Storyboard.ChartLab.parts.hasOwnProperty(part)) {

                var groupName = Storyboard.ChartLab.parts[part].replace(/ /g, '_');
                var setting = $('#' + window.id + ' ' + 'input[name="' + groupName + '"]:checked').val();
                part = $.extend(part, {
                    part: groupName,
                    flag: setting
                });
                parts.push(part);
            }

        var data = {
            reportId: Helpers.getReportID(),
            disabled: !enableChartlab,
            settings: parts,
            chartMode: chartMode,
            elementItem: elementItem
        };

        Helpers.perfJSonCall({
            method: "SaveChartLabSettings",
            service: 'chartsetup',
            data: data,
            successCallback: function () {
                Storyboard.LayoutControls.showMessage(locale.get('Optional Chart settings have been saved'));
                if (window) window.Close();
            },
            failedCallback: function () {
                evt.stopImmediatePropagation();
                Storyboard.LayoutControls.showMessage(locale.get('Unable to save Optional Chart settings'));
            },
            fixCasing: false
        });
    }

    function check() {
        var anyUnchecked = false;
        for (var part in Storyboard.ChartLab.parts)
            if (Storyboard.ChartLab.parts.hasOwnProperty(part)) {

                var groupName = Storyboard.ChartLab.parts[part].replace(/ /g, '_');
                if ($('input:radio[name="' + groupName + '"]:checked').length == 0)
                    anyUnchecked = true;
            }
        if (anyUnchecked == false) {
            $('.DUI-WINDOW-BUTTONS > INPUT.focused').removeAttr('disabled');
            clearInterval(Storyboard.ChartLab.Setup.checkSetupIntervalID);
        }
    }

    function hideShowSelectButtons() {
        // hide/show button next to Select item
        $('.ChartLabSetupPart').each(function () {
            hideShowButton(this);
        });
    }

    function hideShowButton(part) {
        if ($(part).find('[type="radio"][value="2"]').is(':checked')) {
            $(part).find('[type="button"]').show();
            $(part).find('[type="radio"][value="2"] + label').hide();
        } else {
            $(part).find('[type="button"]').hide();
            $(part).find('[type="radio"][value="2"] + label').show();
        }
    }

    function loadCustomSettings(evt) {
        var partName = evt.target.id.replace("btn_", "").replace("_", " ").replace("_", " ");

        var data = {
            reportId: Helpers.getReportID(),
            chartMode: chartMode,
            layoutElementItem: elementItem
        };

        Helpers.perfJSonCall({
            method: "LoadOptionalChartSettings",
            service: 'chartsetup',
            data: data,
            successCallback: function (settings) {
                Storyboard.ChartLab.Setup.optionalSettings = settings;
                Storyboard.ChartLab.Setup.setOptionalSettings(partName, settings);
            },
            failedCallback: function () {
                evt.stopImmediatePropagation();
                Storyboard.LayoutControls.showMessage(locale.get('Unable to load optional chart settings'));
            },
            fixCasing: true
        });
	}

	function checkIfMasterLayoutChecked() {
		var masterLayoutSelected = document.querySelectorAll('.master-layout.default-layout').length;
		var isMasterLayoutCheckedSC = document.getElementById("chbEnableMasterSlideLayout");
		if (isMasterLayoutCheckedSC.checked && masterLayoutSelected < 1) return false;
		return true;
    }

	function setOptionalSettingsForCT(settings) {
		var vSettings = $("#setupOptionalChartSettings");
		vSettings.show();
		$('#setupOptionalChartSettings').find('>div p[class="Message Message-error"]').remove();
		$("#fsGeneral input[type='checkbox']").attr("checked", "checked");
		$("#fsGeneral, #btnImportOptionalChartSettings").hide();
		$("#dynamicFilteringProperties").addClass("reportDisabled").hide();
		$("#tblSigTestAndBencmark_optCt").show();
		$("#tblTimePeriod tbody tr").each(function () {
			if ($(this).find("#hidTimePeriodId").val() == 20)
				$(this).find('input[id^="chbTimePeriodEnabled"]').attr("checked", "checked").attr("disabled", "disabled");
		});
		$("#tblIntervals tbody tr").each(function () {
			if ($(this).find("#hidIntervalId").val() == 7)
				$(this).find('input[id^="chbIntervalEnabled"]').attr("checked", "checked").attr("disabled", "disabled");
		});
		$("#chblMovingAverage input[value='1']").attr("checked", "checked").attr("disabled", "disabled");

		Storyboard.ChartLab.Setup.setupOptionalChartSettings("", settings);
		Storyboard.ChartLab.Setup.bindEvents();

		var buttons = [
			{
				text: 'Save', focused: true, onClick: function () {
					if (checkIfMasterLayoutChecked()) Storyboard.ChartLab.Setup.closeCustomSettings();
				}
			},
			{
				text: 'Cancel',
				onClick: function () {
					if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
						ChartCreatorSetup.cancelReportSettings();
					}
					
					if (window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE) {
						CrossTable2Setup.cancelCrossTableSettings();
					}
				}
			}
		];
		var vWnd = openCustomSettings(buttons);
		$("#" + vWnd.id + " .DUI-WINDOW-BODY").append(vSettings);

		$("#" + vWnd.id + " .DUI-WINDOW-BUTTONS > INPUT[id$=\"_btn0\"]").click(function (evt) {
			$('#setupOptionalChartSettings').find('>div p[class="Message Message-error"]').remove();

			if (!checkIfMasterLayoutChecked()) {
				new DUIwindow2({
					width: 400,
					closeButton: true,
					title: '<h2>Change Master slide PPT</h2>',
					html: '<p class="Message Message-warning">Please select what layout should be the default report slide.</p>',
					modal: true,
					buttons: [
						{
							text: 'Close'
						}
					]
				}); 
				return false;
			}

			if (!checkIsCalcSelected()) {
				$('#setupOptionalChartSettings').find('#fsCTypes').first().after('<p class="Message Message-error">At least one calculation type needs to be selected</p>');
				return false;
			} 
			if (!isAnyDateChecked()) {
				$('#setupOptionalChartSettings').find('#fsTimePeriods').first().after('<p class="Message Message-error">At least one date variable needs to be selected</p>');
				return false;
			}
			if (!isAnyWeightChecked()) {
				$('#setupOptionalChartSettings').find('#fsWeighting').first().after('<p class="Message Message-error">At least one weight variable needs to be selected</p>');
				return false;
			}
				var CTSettings = Storyboard.ChartLab.Setup.getCustomSettingsFromGui();
				Storyboard.GeneralSettings.saveHFilterSettings();

			if (window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE) {
					CrossTable2Setup.saveReportSettings(CTSettings);
					Storyboard.LayoutDesigner.setDeviceLimitationSettings();
					Storyboard.LayoutDesigner.updateDeviceLimitSettings(Storyboard.LayoutDesigner.deviceLimitEnabled, Storyboard.LayoutDesigner.getEnabledScreenTypes());
				} else if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
					ChartCreatorSetup.saveReportSettings(CTSettings);
					Storyboard.LayoutDesigner.setDocFormatSettings();
					Storyboard.LayoutDesigner.saveChartCreatorReportFormat();
				}
			});
	}
	
    function setOptionalSettings(partName, settings) {
        var pagePart, headerText;

        headerText = partName.replace(/_/g, ' ');

        var vSettings = $("#setupOptionalChartSettings");
        vSettings.show();
        Storyboard.ChartLab.Setup.setupOptionalChartSettings(headerText, settings);

        pagePart = vSettings;

        var buttons = [{ text: 'Save', focused: true, closeWindow: false }, { text: 'Cancel' }];
        var vWnd = openCustomSettings(buttons);
        $('#' + vWnd.id + '').prepend('<div class="DUI-WINDOW-HEADER">' + headerText + '</div>');
        $('#' + vWnd.id + ' .DUI-WINDOW-BODY').append(pagePart);

        $('#' + vWnd.id + ' .DUI-WINDOW-BUTTONS > INPUT[id$="_btn0"]').click(function (evt) {
            $('#setupOptionalChartSettings').find('>div p[class="Message Message-error"]').remove();
            if (!checkIfValid()) {
                $('#setupOptionalChartSettings').find('>div >div').first().after('<p class="Message Message-error">Please select at least one option..</p>');
            } else {
                $('#setupOptionalChartSettings').find('>div p[class="Message Message-error"]').remove();
                Storyboard.ChartLab.Setup.closeCustomSettings();
                $('.ChartLabSetupPart [type="radio"]').closest('.ChartLabSetupPart').find('[type="button"]').each(function () {
                    if ($(this).data("isCaller")) {
                        $(this).closest('.ChartLabSetupPart').find('[type="button"]').show();
                        $(this).closest('.ChartLabSetupPart').find('[type="radio"][value="2"] + label').hide();

                        $(this).removeData("isCaller");
                    }
                });
                vWnd.Close();
                Storyboard.ChartLab.Setup.saveCustomSettings(evt, partName);
            }
        });
        $('#' + vWnd.id + ' .DUI-WINDOW-BUTTONS > INPUT[id$="_btn1"]').click(function (evt) {
            $('#setupOptionalChartSettings').find('>div p[class="Message Message-error"]').remove();
			$('.ChartLabSetupPart [type="radio"]').closest('.ChartLabSetupPart').find('[type="button"]').each(function () {
				if ($(this).data("isCaller")) {
					if (!checkIfValid()) {
						$(this).closest('.ChartLabSetupPart').find('[type="radio"]').first().attr('checked', 'checked');
						$(this).closest('.ChartLabSetupPart').find('[type="button"]').hide();
						$(this).closest('.ChartLabSetupPart').find('[type="radio"][value="2"] + label').show();
					} else {
						$(this).closest('.ChartLabSetupPart').find('[type="button"]').show();
						$(this).closest('.ChartLabSetupPart').find('[type="radio"][value="2"] + label').hide();
					}

					$(this).removeData("isCaller");
				}
			});
            vWnd.Close();
        });
        $('#' + vWnd.id + ' .DUI-WINDOW-CLOSE').click(function (evt) {
            $('#setupOptionalChartSettings').find('>div p[class="Message Message-error"]').remove();
			$('.ChartLabSetupPart [type="radio"]').closest('.ChartLabSetupPart').find('[type="button"]').each(function () {
				if ($(this).data("isCaller")) {
					if (!checkIfValid()) {
						$(this).closest('.ChartLabSetupPart').find('[type="radio"]').first().attr('checked', 'checked');
						$(this).closest('.ChartLabSetupPart').find('[type="button"]').hide();
						$(this).closest('.ChartLabSetupPart').find('[type="radio"][value="2"] + label').show();
					} else {
						$(this).closest('.ChartLabSetupPart').find('[type="button"]').show();
						$(this).closest('.ChartLabSetupPart').find('[type="radio"][value="2"] + label').hide();
					}

					$(this).removeData("isCaller");
				}
			});
            vWnd.Close();
        });
    }

    function checkIfValid() {
        var isValid = false;
        $('#setupOptionalChartSettings >div >div').filter(':visible').find('fieldset').each(function () {
            var fieldsetId = $(this).attr('id');

            // do not validate fsGeneral fieldset
            if (fieldsetId === 'fsGeneral') return true;

            if (fieldsetId === 'fsChartTypes' || fieldsetId === 'fsSeriesOption') {
                if ($(this).find('input[type="checkbox"]:checked').length !== 0) 
                    isValid = true;
            } else {
                if ($(this).find('table').filter(function () { return this.style.display !== "none"; }).find('input[type="checkbox"]:checked').length !== 0)
                    isValid = true;
            }
        });

        return isValid;
    }

	function setupLayoutTemplatesValidations() {
		var marginLeft = $('#txtLayoutMarginLeft');
		var marginRight = $('#txtLayoutMarginRight');
		var marginTop = $('#txtLayoutMarginTop');
		var marginBottom = $('#txtLayoutMarginBottom');

		var validateMargins = function() {
			var top = parseInt(marginTop.val(), 10);
			var bottom = parseInt(marginBottom.val(), 10);
			var left = parseInt(marginLeft.val(), 10);
			var right = parseInt(marginRight.val(), 10);

			if ((top + bottom) >= 100) {
				$('#divLayoutTemplateValidation').html('<p class="Message Message-error">'+ locale.get('The top/bottom margins are too large for the slide height.') +'</p>');
			} else if ((left + right) >= 100) {
				$('#divLayoutTemplateValidation').html('<p class="Message Message-error">'+ locale.get('The left/right margins are too large for the slide width.') +'</p>');
			} else {
				$('#divLayoutTemplateValidation').empty();
			}
		}

		marginLeft
			.add(marginRight).add(marginTop).add(marginBottom)
			.unbind('change')
			.bind('change', validateMargins);

		validateMargins();
	}

    function openCustomSettings(btns) {
        var settings = {
            width: 870,
            height: 'auto',
            topPosition: '40px',
            backgroundColor: '#fff',
            cssClass: 'setup-optional-chart-settings',
            modal: true,
            preWrapSpace: false,
            buttons: btns,
            beforeClose: function () {
                Storyboard.ChartLab.Setup.closeCustomSettings(true);
            }
        };

        if (arguments.length > 0)
            $(settings).extend(true, settings, arguments[0]);

        return new DUIwindow2(settings);
    }

    function saveCustomSettings(evt, partName) {
        evt.preventDefault();

        var data = {
            reportId: Helpers.getReportID(),
            chartMode: chartMode,
            settings: Storyboard.ChartLab.Setup.getCustomSettingsFromGui(partName),
            layoutElementItem: elementItem
        };

        Helpers.perfJSonCall({
            method: "SaveOptionalChartSettings",
            service: 'chartsetup',
            data: data,
            successCallback: function () {
                Storyboard.LayoutControls.showMessage(locale.get('Optional chart settings have been saved'));
                setTimeout(Storyboard.LayoutControls.hideLoadingBar, 2000);
            },
            failedCallback: function () {
                evt.stopImmediatePropagation();
                Storyboard.LayoutControls.showMessage(locale.get('Unable to save optional chart settings'));
            },
            fixCasing: false
        });
    }

	function getCustomSettingsFromGui(partName) {
		var settingsToSave = structuredClone(Storyboard.ChartLab.Setup.optionalSettings) || {};
		var parts = [partName];
		var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;

		if (window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE)
			parts = ["Variables", "Time periods", "Weighting", "Base limits", "Optional features", "Hierarchical filters", "Device limitation",
				'Static filters', 'Favorites and sharing', 'Table key', 'Export options', 'Base'];
		else if (isChartCreator)
			parts = ["Variables", "Filters", "Time periods", "Weighting", "Base limits", "Optional features", "Hierarchical filters", "Change chart type", "Report format",
				"Export format", "Device limitation", 'Smart functions', 'Layout templates', 'Color templates', 'Static filters'];

		for (var i = 0; i < parts.length; i++)
			switch (parts[i]) {
				case Storyboard.ChartLab.parts[0]:
					var generalSettings = 0;
					//  Variables
					$("#fsGeneral input:checked").each(function () {
						generalSettings += parseInt($(this).val() || 0, 10);
					});

					var qnBlocks = [];
					$(".qnBlockItem input:checked").each(function () {
						qnBlocks.push($(this).val());
					});

					$('#tblQns').dataTable().fnDestroy();
					
					var qns = [];

					$(".qnItem input:checked").each(function () {
						qns.push($(this).val());
					});

					// Variable subsets
					var vSubsets = [];
					$("[id*=chblVarSubsets] input:checked").each(function () {
						vSubsets.push($(this).val());
					});

					var cTypes = [];
					var cTypesSettings = [];
					$("#tblCTypes tbody tr").each(function () {
						if ($(this).find('input[id^="chbCTypeEnabled"]').is(":checked")) {
							cTypes.push($(this).find("#hidCTypeId").val());
							cTypesSettings.push({
								calculationTypeId: $(this).find("#hidCTypeId").val(),
								noOfDecimals: $(this).find("#ddlCTypeDefNoOfDecimals").val() || 1,
								unitText: $(this).find("#txtCTypeDefUnitText").val() || "",
								unitPlacement: $(this).find("#ddlCTypeDefUnitPlacement").val() || 0
							});
						}
					});

					settingsToSave["generalSettings"] = generalSettings;
					settingsToSave.questionBlocks = qnBlocks;
					settingsToSave.questions = qns;
					settingsToSave.variableSubsets = vSubsets;
					settingsToSave.calculationTypes = cTypes;
					settingsToSave.calculationsSettings = cTypesSettings;
					settingsToSave.includeAllQuestionBlocks = $("#optQnrBAll_ct").is(":checked");
					settingsToSave.includeAllQuestions = $("#optQnrAll_ct").is(":checked");
					settingsToSave.includeAllVariableSubsets = $("#optVarSubsetsAll_ct").is(":checked");
					settingsToSave.includeAllFilters = $('#optFilterAll_cc').is(':checked');
					settingsToSave.varSubsetSelectionType = $("input[name='optVarSubsetSelectType_ct']:checked").val();
					settingsToSave.enableSigTests = $("#chbSigTest_optCt").is(":checked");
					settingsToSave.sigTestsOptions = [];
					settingsToSave.variableSubsetsHeader = $("#txtVariableSubsetsHeader").val();
					$("input:checked[name=chbSigTestOptions_optCt]").each(function () {
						settingsToSave.sigTestsOptions.push($(this).val());
					});
					settingsToSave.enableBenchmarks = $("#chbBenchmark_optCt").is(":checked");
					settingsToSave.enableRanking = $("#chbRanking_optCt").is(":checked");
					settingsToSave.enableMean = $("#chbMean_optCt").is(":checked");
					settingsToSave.groupedByQuestionBlock = $("#optQnrBGrouped_ct").is(":checked");
					settingsToSave.allowToShowCodes = $("#optAllowShowCodes_ct").is(":checked");
					settingsToSave.enableZtest = $('#chbEnableZTest_optCt').is(':checked');
					settingsToSave.enableTtest = $('#chbEnableTTest_optCt').is(':checked');
					settingsToSave.enableDepZtest = $('#chbEnableDepZTest_optCt').is(':checked');
					settingsToSave.enableDepTtest = $('#chbEnableDepTTest_optCt').is(':checked');
					settingsToSave.allowRebase = $('#chbAllowRebase').is(':checked');			
					break;
				case Storyboard.ChartLab.parts[1]:
					// Filters
					var filters = [];
					$(".filterItem").each(function () {
						if ($(this).find(".includeFilter").is(':checked')) {
							filters.push({
								filterId: $(this).find(".includeFilter").val(),
								compare: isChartCreator ? true : $(this).find(".allowCompare").is(":checked"),
								defaultDisplayed: $(this).find(".defaultDisplayed").is(":checked")
							});
						}

						if ($(this).find('.allowCompare[wasChanged], .includeFilter[wasChanged]').length > 0)
							settingsToSave.reloadFilters = true;
					});

					if ($('input[name="optFilter_cc"][wasChanged]').length > 0)
						settingsToSave.reloadFilters = true;

					settingsToSave.filters = filters;
					break;
				case Storyboard.ChartLab.parts[2]:
					// Time settings
					var tPeriods = [];
					$("#tblTimePeriod tbody tr").each(function () {
						if ($(this).find('input[id^="chbTimePeriodEnabled"]').is(":checked")) {
							tPeriods.push($(this).find("#hidTimePeriodId").val());
						}
					});

					var mAvg = [];
					$("[id*=chblMovingAverage] input:checked").each(function () {
						mAvg.push($(this).val());
					});

					var intervals = [];
					$("#tblIntervals tbody tr").each(function () {
						if ($(this).find('input[id^="chbIntervalEnabled"]').is(":checked")) {
							intervals.push($(this).find("#hidIntervalId").val());
						}
					});

					var dVariables = [];
					$("#tblDateVariables tbody tr").each(function () {
						if ($(this).find('input[id^="chbDateVariableEnabled"]').is(":checked")) {
							dVariables.push({
								dateVariableId: $(this).find("#hidDateVariableId").val(),
								isDefault: $(this).find("#rbDefaultDateVariable").is(":checked")
							})
						}
					});

					settingsToSave.dateVariables = dVariables;
					settingsToSave.timePeriods = tPeriods;
					settingsToSave.movingAverages = mAvg;
					settingsToSave.timeIntervals = intervals;

					settingsToSave.defaultTimeSelections = {
						interval: $("#hidIntervalId", $(".rbDefaultInterval input:checked").first().closest("tr")).val(),
						period: $("#hidTimePeriodId", $(".rbDefaultTimePeriod input:checked").first().closest("tr")).val(),
						strStartDate: Helpers.formatDate($("#txtDefaultStartDate").datepicker("getDate")),
						strStopDate: Helpers.formatDate($("#txtDefaultStopDate").datepicker("getDate")),
						timePeriodSpan: $("#ddlDefaultPeriodSpan").val() || 1,
						timePeriodSpanAmount: $("#txtDefaultPeriodSpanAmount").val() || 1
					};

					settingsToSave.defaultTimeSelections.startDate = settingsToSave.defaultTimeSelections.strStartDate;
					settingsToSave.defaultTimeSelections.stopDate = settingsToSave.defaultTimeSelections.strStopDate;

					break;
				case Storyboard.ChartLab.parts[3]:
					// Series
					var objectTypes = [];
					$("input[name='chbObjectTypeGroup']:checked").each(function () {
						objectTypes.push(parseInt($(this).val(), 10));
					});

					var chartTypes = [];
					$("input[name='chbCTypeGroup']:checked").each(function () {
						chartTypes.push($(this).val());
					});

					var seriesOptions = [];
					$("input[name='chbSeriesOptionGroup']:checked").each(function () {
						seriesOptions.push($(this).val());
					});

					settingsToSave.objectTypes = objectTypes;
					settingsToSave.seriesTypes = chartTypes;
					settingsToSave.seriesAttributes = seriesOptions;
					settingsToSave.enablePolar = $("#chbPolarCharts_optCc").is(":checked");
					break;
				case Storyboard.ChartLab.parts[5]:
					// Weighting
					settingsToSave.weightedResult = $("#chbWeightedResult_optCt").is(":checked");
					settingsToSave.unweightedResult = $("#chbUnweightedResult_optCt").is(":checked");
					var weights = [];
					$("#tblWeights tbody tr").each(function () {
						if ($(this).find('input[id^="chbWeightVariableEnabled"]').is(":checked")) {
							weights.push({
								weightId: parseInt($(this).find("#hidWeightVariableId").val(), 10),
								isDefault: $(this).find("#rbDefaultWeightVariable").is(":checked")
							})
						}
					});
					settingsToSave.weightVariables = weights;
					break;
				case Storyboard.ChartLab.parts[6]:
					// Base Limits
					var trimSettings = {};
					trimSettings.trimLowResultEnabled = $("#chbTrimLowResult_optCt").is(":checked");
					trimSettings.trimLowResultVisible = $("#chbTrimLowResultShow_optCt").is(":checked");
					trimSettings.trimLowResultValue = $("#txtTrimLowResultValue_Optct").val() || 0;
					trimSettings.trimLowResultType = $("#ddlTrimLowResultType_optCt").val() || 1;

					trimSettings.trimLowBaseEnabled = $("#chbTrimLowBase_optCt").is(":checked");
					trimSettings.trimLowBaseVisible = $("#chbTrimLowBaseShow_optCt").is(":checked");
					trimSettings.trimLowBaseValue = $("#txtTrimLowBaseValue_Optct").val() || 0;
					trimSettings.trimLowBaseType = $("#ddlTrimLowBaseType_optCt").val() || 1;
					trimSettings.baseSizeHideLimitId = $("#tblHideLimitsMain_optCt .rbHideLimitDefault input:checked").val() || 0;

					var availableBaseSizeHideLimitIds = [];
					$("#tblHideLimitsMain_optCt tbody tr").each(function () {
						if ($(this).find('input[id^="chbHideLimitEnabled"]').is(":checked")) {
							availableBaseSizeHideLimitIds.push($(this).find("#hidHideLimitId").val());
						}
					});

					trimSettings.availableBaseSizeHideLimitIds = availableBaseSizeHideLimitIds.length ? availableBaseSizeHideLimitIds.join(",") : "";

					trimSettings.warnLowBaseEnabled = $("#chbWarnLowBase_optCt").is(":checked");
					trimSettings.warnLowBaseVisible = $("#chbWarnLowBaseShow_optCt").is(":checked");
					trimSettings.warnLowBaseValue = $("#txtWarnLowBaseValue_Optct").val() || 0;
					trimSettings.warnLowBaseType = $("#ddlWarnLowBaseType_optCt").val() || 1;
					trimSettings.baseSizeWarningLimitId = $("#tblWarnLimitsMain_optCt .rbWarnLimitDefault input:checked").val() || 0;

					var availableBaseSizeWarningLimitIds = [];
					$("#tblWarnLimitsMain_optCt tbody tr").each(function () {
						if ($(this).find('input[id^="chbWarnLimitEnabled"]').is(":checked")) {
							availableBaseSizeWarningLimitIds.push($(this).find("#hidWarnLimitId").val());
						}
					});

					trimSettings.availableBaseSizeWarningLimitIds = availableBaseSizeWarningLimitIds.length ? availableBaseSizeWarningLimitIds.join(",") : "";

					settingsToSave.trimSettings = trimSettings;
					break;
				case Storyboard.ChartLab.parts[7]:
					// Optional features
					settingsToSave.enableComputes = $("#chbComputeVariables_ct").is(":checked");
					settingsToSave.enableFormattingRules = $("#chbFormattingRules_ct").is(":checked");
					settingsToSave.deckAccessType = $('input.deckAccessMode:checked').length > 0 ? $('input.deckAccessMode:checked').val() : 3;
					settingsToSave.enableDeckFilters = $('#chbEnableDeckFilters_cc').is(':checked');
					if (isChartCreator) {
						settingsToSave.enableSharedFavorites = $("#chbSharedFavorites").is(":checked");
						settingsToSave.favoriteSharingType = 0;
						$('input.faveSharingType:checked').each(function () {
							settingsToSave.favoriteSharingType += parseInt($(this).val() || 0, 10);
						});
						settingsToSave.enableCollaboration = $('#chbEnableCollaboration').is(':checked');
						settingsToSave.enableClipboard = $('#chbClipboard_cc').is(':checked');
					}
					break;
				case Storyboard.ChartLab.parts[12]:
					// Smart functions
					settingsToSave.applySmartPositioning = $("#chbSmartPositioning").is(":checked");
					settingsToSave.enableRecommendations = $("#chbChartTypeRecommendations").is(":checked");
					break;
				case Storyboard.ChartLab.parts[13]:
					// Layout templates
					settingsToSave.layoutSettings = {
						enableLayoutTemplates: $("#chbEnableLayoutTemplates").is(":checked"),
						enableMasterSlideLayout: $("#chbEnableMasterSlideLayout").is(":checked"),
						masterLayoutFileName: $("#masterLayoutFileName").text(),
						defaultMasterLayoutId: $("#divMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId").val(),
						marginLeft: $("#txtLayoutMarginLeft").val(),
						marginRight: $("#txtLayoutMarginRight").val(),
						marginTop: $("#txtLayoutMarginTop").val(),
						marginBottom: $("#txtLayoutMarginBottom").val(),
						marginBetween: $("#txtLayoutMarginBetween").val(),
						slideTitleHeight: $('#txtSlideTitleHeight').val(),
						slideSubtitleHeight: $('#txtSlideSubtitleHeight').val(),
						slideFooterHeight: $('#txtSlideFooterHeight').val()
					};
					break;
				case Storyboard.ChartLab.parts[14]:
					settingsToSave.allColorCategories = $('#optColorsAll_cc').is(':checked');
					settingsToSave.colorCategories = [];
					$('input.colorCatInclude_cc[type="checkbox"]:checked').each(function () {
						settingsToSave.colorCategories.push({
							colorCategoryId: $(this).val(),
							colorTemplateId: $('#hidColorTemplateId').val()
						});
					});
					break;
				case Storyboard.ChartLab.parts[15]:
					settingsToSave.hideStaticFiltersInfo = $('#chbHideStaticFiltersInfo').is(':checked');
					settingsToSave.staticFilters = [];
					$('#tblStaticFilters > tbody > tr:not(.staticFilterRowTemplate)').each(function () {
						var row = $(this);
						var staticFilter = {
							questionId: $('select.ddlStaticFilterQuestion option:selected', row).val() || 0,
							filterId: $('select.ddlStaticFilterQuestion option:selected', row).attr('filterId') || 0,
							answerIds: $('select.ddlStaticFilterOption', row).multiselect('getChecked').map(function () { return this.value; }).get()
						};

						if (staticFilter.questionId > 0 && staticFilter.answerIds.length > 0)
							settingsToSave.staticFilters.push(staticFilter);
					});
					if ($('#tblStaticFilters[wasChanged]').length > 0)
						settingsToSave.reloadFilters = true;
					break;
				case Storyboard.ChartLab.parts[16]:
					settingsToSave.enableFavorites = $("#chbFavorites_ct").is(":checked");
					settingsToSave.enableWorkbooks = $('#chbWorkbooks_ct').is(':checked');
					settingsToSave.enableSharedFavorites = $("#chbSharedFavorites").is(":checked");
					settingsToSave.enableCollaboration = $('#chbEnableCollaboration').is(':checked');
					settingsToSave.enableClipboard = $('#chbClipboard_ct').is(':checked');
					settingsToSave.favoriteSharingType = 0;
					$('#fsFavoritesAndSharing input.faveSharingType:checked').each(function () {
						settingsToSave.favoriteSharingType += parseInt($(this).val() || 0, 10);
					});
					break;
				case Storyboard.ChartLab.parts[18]: // Table key
					settingsToSave.tableKeys = 0;
					$('#fsTableKey input.tableKeyItem:checked').each(function () {
						settingsToSave.tableKeys += parseInt($(this).val() || 0, 10);
					});
					break;
				case Storyboard.ChartLab.parts[19]: // Export Options
					settingsToSave.googleSheetsExport = $('#chbGoogleSheetsExport').is(':checked');
					if (settingsToSave.googleSheetsExport) {
						$('#btnOpenGoogleExportPanel_ct').show();
					}
					else {
						$('#btnOpenGoogleExportPanel_ct').hide();
                    }
					break;

				case Storyboard.ChartLab.parts[20]: // Base
					settingsToSave.weightedBase = $("#chbWeightedBase_ct").is(":checked");
					settingsToSave.unweightedBase = $("#chbUnweightedBase_ct").is(":checked");
					settingsToSave.effectiveBase = $("#chbEffectiveBase_ct").is(":checked");
					break;
			}
		return settingsToSave;
	}

	function setupOptionalChartSettings(settingsPart, optSettings) {
		$('#divVarSettings, #divFiltersSettings, #divTimePeriods, #divChartTypes').hide();
		$('#divWeighting, #divBaseLimits, #divOptionalFeatures, #divHfilters, #divDeviceLimitSettings, #divReportDocFormatSettings,' +
			'#divExportDocFormatSettings, #divSmartLogicSettings, #divLayoutTemplateSettings, #divColorTemplateSettings,' + 
			'#divStaticFilterSettings, #divFavoritesAndSharing, #divAutoTableCreation, #divTableKey, #divExportOptions, #divBase').hide();

		$('#chbAllQns').removeAttr('checked');
		$('#chbAllQnBs').removeAttr('checked');

		var parts = [];
		if (window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE) {
			parts = ["Variables", "Time periods", "Weighting", "Base limits", "Optional features", "Hierarchical filters",
				"Device limitation", 'Static filters', 'Favorites and sharing', 'Automatic table creation', 'Table key', 'Export options', 'Base'];
			$("#chbMean_optCt").closest("tr").hide();
		} else if (window.ContentType == Storyboard.Constants.itemTypes.CHART) {
			parts = ["Variables", "Filters", "Time periods", "Weighting", "Base limits", "Optional features", "Hierarchical filters", "Change chart type", "Report format",
				"Export format", "Device limitation", 'Smart functions', 'Layout templates', 'Color templates', 'Static filters'];
			$(".questionListLayout_ct").hide(); // do not group by question block in version 1
			$("#chbComputeVariables_ct, #chbFormattingRules_ct").closest("tr").hide();
			$('#divOptionalFeatures .settingsFieldsetLegend').contents().first().replaceWith(locale.get('Decks'));
			$('#cbExportFormatPrint').closest('.settingItem').hide();
			$('input[name="chbCTypeGroup"][value="13"], input[name="chbCTypeGroup"][value="14"]').closest('tr').hide();
			$('#ddlReportDocFormat option[value="8"]').remove();
			$('#cbSmallDeviceEnabled').closest('tr').hide();
			$('#ddlExportType').closest('.settingItem').hide();
			$('#fsObjectTypes').parent().show();
			$('#fsChartTypes, #fsSeriesOption').parent().removeClass('size-1-2').addClass('size-1-3');
			$('#cbExportFormatExcel').parent().find('.Message-simple.Message-excel').text(
				'Note: The export to Excel is a non styled extract of the chart and table results to an Excel file. Text boxes are not included in the export.');
			$("#optFilterAll_cc").closest(".allVsCustom_ct").show();
			$("#fsWeighting").parent().removeClass('size-1-2');

			$('.divCTWrnMsg').hide();
			// move sharing settings controls to Deck settings panel
			$('#divDeckSharingType').after($('#divSharingSetup'));
		} else {
			$(".allVsCustom_ct, .optDefaultInterval, .optDefaultPeriod, .cTypeDecUnit_ct, .questionListLayout_ct").hide();
			parts.push(settingsPart);
		}

		var singleObjectMode = window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE ||
			window.ContentType == Storyboard.Constants.itemTypes.CHART;
		var personalEdition = window.IsPersonalEdition.toLowerCase() === 'true';
		var isStoryCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;
		var personalEditionStoryCreator = personalEdition && isStoryCreator;

		for (var i = 0; i < parts.length; i++) {
			switch (parts[i]) {
				case Storyboard.ChartLab.parts[0]:
					if (!personalEditionStoryCreator)
						$('#divVarSettings').show();

					if ($("#tblQns > tbody > .qnItem").length > 0) { // questions table has already been populated
						Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
						if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE)
							Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(Storyboard.ChartLab.parts[15], optSettings);
					} else // populate questions table
						bindQuestions(optSettings);

					if (singleObjectMode && $("[id*=chblVarSubsets] input").length > 0)
						$("#fsVariableSubsets").show();
					break;
				case Storyboard.ChartLab.parts[1]:
					if (!personalEditionStoryCreator)
						$('#divFiltersSettings').show();
					if ($("#tblFilters > tbody > .filterItem").length > 0) { // filters table has already been populated
						Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
						if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
							Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(Storyboard.ChartLab.parts[15], optSettings);
					} else // populate questions table
						bindFilters(optSettings);
					break;
				case Storyboard.ChartLab.parts[2]:
					if (!personalEditionStoryCreator)
						$('#divTimePeriods').show();
					if (!isStoryCreator)
						$('#divDateVariables').show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[3]:
					if (!personalEditionStoryCreator)
						$('#divChartTypes').show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[5]:
					if (!personalEditionStoryCreator)
						$('#divWeighting').show();
					if (!isStoryCreator)
						$('#tblWeights').show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[6]:
					if (!personalEditionStoryCreator)
						$('#divBaseLimits').show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[7]:
					$('#divOptionalFeatures').show();
					if (personalEditionStoryCreator)
						$('#divOptionalFeatures .settingsFieldsetContent:not(.divDeckFilters_cc)').hide();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[8]:
					if ($("#hfilterSetupContainerPanel .AdminSetting").length > 0)
						if (!personalEditionStoryCreator)
							$('#divHfilters').show();
					break;
				case Storyboard.ChartLab.parts[9]:
					if (!personalEditionStoryCreator)
						$("#divDeviceLimitSettings").show();
					Storyboard.LayoutDesigner.bindDeviceLimitSettings();
					Storyboard.LayoutDesigner.showHideScreenTypes();
					break;
				case Storyboard.ChartLab.parts[10]:
					//$("#divReportDocFormatSettings").show();
					//Storyboard.LayoutDesigner.bindReportFormatSettings();
					//Storyboard.LayoutDesigner.showHideDocFormatSettingsByType();
					break;
				case Storyboard.ChartLab.parts[11]:
					$("#divExportDocFormatSettings").show();
					Storyboard.LayoutDesigner.bindExportSettings();
					break;
				case Storyboard.ChartLab.parts[12]:
					if (!personalEditionStoryCreator)
						$("#divSmartLogicSettings").show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[13]:
					$("#divLayoutTemplateSettings").show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					Storyboard.LayoutDesigner.bindReportFormatSettings();
					Storyboard.LayoutDesigner.showHideDocFormatSettingsByType();
					break;
				case Storyboard.ChartLab.parts[14]:
					if (!personalEditionStoryCreator)
						$("#divColorTemplateSettings").show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[15]:
					if (!personalEditionStoryCreator)
						$('#divStaticFilterSettings').show();
					// selections are set in parts[0] (CT2) or parts[1] (Story creator) after qns/filters were loaded
					break;
				case Storyboard.ChartLab.parts[16]:
					$('#divFavoritesAndSharing').show();
					if (personalEdition) {
						$('#divFavoritesAndSharing .settingItem:not(.enableFavorites)').hide();
						$('#lblFavesAndSharing').text('Favorites');
					}
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[18]: // Table key
					$('#divTableKey').show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
				case Storyboard.ChartLab.parts[19]:// Export Options
                    if (optSettings == null) {
						CrossTable2Setup.enableGoogleSheetsExport()
                    }
					else if ((optSettings.enableGoogleSheetsExport == undefined && optSettings.googleSheetsExport) || optSettings.enableGoogleSheetsExport){
						$('#divExportOptions').show();
						Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					}
					break;
				case Storyboard.ChartLab.parts[20]: //Base
					if (!personalEditionStoryCreator && !isStoryCreator)
						$('#divBase').show();
					Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(parts[i], optSettings);
					break;
			}

			if (window.ContentType != Storyboard.Constants.itemTypes.CROSSTABLE)
				$('#btnImportOptionalChartSettings').unbind('click').click(function () {
					Storyboard.GuiEvents.ImportOptionalChartSettings.showImportGui(parts[i - 1]);
				});
		}
	}

	function setOptionalChartSettingsForPart(settingsPart, optSettings) {
		var singleObjectMode = window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE ||
			window.ContentType == Storyboard.Constants.itemTypes.CHART;
		var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;

		switch (settingsPart) {
			case Storyboard.ChartLab.parts[0]:
				var qnTable = null;
				var qnBlocksTable = null;

				$('#tblQns').dataTable().fnDestroy();
				$('#tblQnBlocks').dataTable().fnDestroy();

				// Variables
				if (optSettings)
					$('#fsGeneral [type="checkbox"]').each(function () {
						var val = parseInt($(this).val() || 0, 10);
						$(this).attr("checked", (val & optSettings.generalSettings) == val);
					});

				showHideFieldset($('#fsQBlocks'), $('#chbQuestionBlocks').is(':checked'));
				showHideFieldset($('#fsQuestions'), $('#chbQuestions').is(':checked'));
				showHideFieldset($('#fsCTypes'), $('#chbCalculationTypes').is(':checked'));

				$('.qnBlockItem [type="checkbox"]').removeAttr('checked');
				$('.qnItem [type="checkbox"]').removeAttr('checked');
				$(".chbCTypeEnabled").removeAttr("checked");
				$(".cTypeDecUnit_ct select, .cTypeDecUnit_ct input").hide();

				$("#tblCTypes tbody tr").each(function () {
					var id = $(this).find("#hidCTypeId").val();
					$(this).find('input[id^="chbCTypeEnabled"]').attr('id', 'chbCTypeEnabled' + id);
					$(this).find('label[for^="chbCTypeEnabled"]').attr('for', 'chbCTypeEnabled' + id);
				});

				if (optSettings) {
					if (optSettings.includeAllQuestionBlocks) $("#optQnrBAll_ct").attr("checked", "checked");
					else $("#optQnrBCustom_ct").attr("checked", "checked");

					if (optSettings.groupedByQuestionBlock) $("#optQnrBGrouped_ct").attr("checked", "checked");
					else $("#optQnrBFiltered_ct").attr("checked", "checked");

					if (optSettings.includeAllQuestions) $("#optQnrAll_ct").attr("checked", "checked");
					else $("#optQnrCustom_ct").attr("checked", "checked");

					for (var i = 0; i < optSettings.questionBlocks.length; i++)
						$('.qnBlockItem [type="checkbox"][value="' + optSettings.questionBlocks[i] + '"]').attr('checked', 'checked');

					for (i = 0; i < optSettings.questions.length; i++)
						$('.qnItem [type="checkbox"][value="' + optSettings.questions[i] + '"]').attr('checked', 'checked');

					for (i = 0; i < optSettings.calculationTypes.length; i++) {
						$("#tblCTypes tbody tr").each(function () {
							if ($(this).find("#hidCTypeId").val() == optSettings.calculationTypes[i]) {
								$(this).find("input[id^='chbCTypeEnabled']").attr("checked", "checked");
								$(this).find(".cTypeDecUnit_ct select, .cTypeDecUnit_ct input").show();
							}
						});
					}

					for (i = 0; i < optSettings.calculationsSettings.length; i++) {
						var cSetting = optSettings.calculationsSettings[i];
						$("#tblCTypes tbody tr").each(function () {
							if ($(this).find("#hidCTypeId").val() == cSetting.calculationTypeId) {
								$(this).find("#ddlCTypeDefNoOfDecimals").val(cSetting.noOfDecimals);
								$(this).find("#txtCTypeDefUnitText").val(cSetting.unitText);
								$(this).find("#ddlCTypeDefUnitPlacement").val(cSetting.unitPlacement);
							}
						});
					}

					if (optSettings.includeAllVariableSubsets) $("#optVarSubsetsAll_ct").attr("checked", "checked");
					else $("#optVarSubsetsCustom_ct").attr("checked", "checked");

					$("input[name='optVarSubsetSelectType_ct']").each(function () {
						if ($(this).val() == optSettings.varSubsetSelectionType)
							$(this).attr("checked", "checked");
						else
							$(this).removeAttr("checked");
					});

					$("#txtVariableSubsetsHeader").val(optSettings.variableSubsetsHeader);

					$("[id*=chblVarSubsets] [type='checkbox'][value]").removeAttr("checked");
					for (i = 0; i < optSettings.variableSubsets.length; i++)
						$("[id*=chblVarSubsets] [type='checkbox'][value='" + optSettings.variableSubsets[i] + "']").attr("checked", "checked");

					$("#chbSigTest_optCt").attr("checked", optSettings.enableSigTests);
					$("input[name=chbSigTestOptions_optCt]").removeAttr("checked");
					$(optSettings.sigTestsOptions).each(function () {
						$("input[name=chbSigTestOptions_optCt][value='" + this + "']").attr("checked", "checked");
					});
					$("#chbBenchmark_optCt").attr("checked", optSettings.enableBenchmarks);
					$("#chbRanking_optCt").attr("checked", optSettings.enableRanking);
					$("#chbMean_optCt").attr("checked", optSettings.enableMean);
					$("#optAllowShowCodes_ct").attr("checked", optSettings.allowToShowCodes);
					$('#chbEnableZTest_optCt').attr('checked', optSettings.enableZtest);
					$('#chbEnableTTest_optCt').attr('checked', optSettings.enableTtest);
					$('#chbEnableDepZTest_optCt').attr('checked', optSettings.enableDepZtest);
					$('#chbEnableDepTTest_optCt').attr('checked', optSettings.enableDepTtest);
					$('#chbAllowRebase').attr('checked', optSettings.allowRebase);
				} else if (singleObjectMode) {
					$("#optQnrBAll_ct").attr("checked", "checked");
					$("#optQnrAll_ct").attr("checked", "checked");
					$(".chbCTypeEnabled input").attr("checked", "checked");
					$(".cTypeDecUnit_ct select, .cTypeDecUnit_ct input").show();
					$('#chbEnableZTest_optCt').attr('checked', 'checked');
					$('#chbEnableTTest_optCt').attr('checked', 'checked');
					$('#chbEnableDepZTest_optCt, #chbEnableDepTTest_optCt').attr('checked', 'checked');
					if (typeof allowRebaseByDefault !== 'undefined') { $('#chbAllowRebase').attr('checked', allowRebaseByDefault); }
				}

				if (singleObjectMode) {
					$("#optQnrBAll_ct").closest(".allVsCustom_ct").next(".settingItem").toggle(!$("#optQnrBAll_ct").is(":checked"));
					$("#optQnrAll_ct").closest(".allVsCustom_ct").next(".settingItem").toggle(!$("#optQnrAll_ct").is(":checked"));
					$("#optVarSubsetsAll_ct").closest(".allVsCustom_ct").next(".settingItem").toggle(!$("#optVarSubsetsAll_ct").is(":checked"));
					showHideFieldset($('#fsQBlocks'), $("#tblQnBlocks tr.qnBlockItem").length > 0);
					if (window.ContentType == Storyboard.Constants.itemTypes.CROSSTABLE)
						$('.questionListLayout_ct').css('display', 'block');
					if (window.ContentType != Storyboard.Constants.itemTypes.CROSSTABLE)
						$(".cTypeDecUnit_ct.unitPlacement select").hide();
				}
							
				qnTable = $('#tblQns').dataTable({
					"bDestroy": true,
					"sPaginationType": "full_numbers",
					"aaSorting": [],
					"sDom": '<"top"f>rt<"bottom"lp>',
					"aoColumnDefs": [{ 'bSortable': false, 'aTargets': [4] }]
				});
				$('#tblQns').css("width", "100%");

				qnBlocksTable = $('#tblQnBlocks').dataTable({
					"bDestroy": true,
					"bPaginate": false,
					"aaSorting": [],
					"sDom": '<"top"f>rt',
					"aoColumnDefs": [{ 'bSortable': false, 'aTargets': [2] }]
				});
				$('#tblQnBlocks').css("width", "100%");

				$("#optQnrCustom_ct").bind("change", function (evt) {
					const tblQns = document.getElementById("tblQns");
					if (evt.target.checked && !tblQns.parentElement.classList.contains('dataTables_wrapper')) {
						qnTable = $('#tblQns').dataTable({
							"bDestroy": true,
							"sPaginationType": "full_numbers",
							"aaSorting": [],
							"sDom": '<"top"f>rt<"bottom"lp>',
							"aoColumnDefs": [{ 'bSortable': false, 'aTargets': [4] }]
						});
					}
				});

				$('#chbAllQns').unbind('click').click(function () {
					var chk = $(this).is(':checked');
					$('input:checkbox', qnTable.fnGetNodes()).attr('checked', chk);
				})

				$('#chbAllQnBs').unbind('click').click(function () {
					var chk = $(this).is(':checked');
					$('input:checkbox', qnBlocksTable.fnGetNodes()).attr('checked', chk);
				});
				break;
			case Storyboard.ChartLab.parts[1]:
				// Filters
				$('.filterItem [type="checkbox"]').removeAttr('checked');

				if (optSettings) {
					if (optSettings.includeAllFilters) $("#optFilterAll_cc").attr("checked", "checked");
					else $("#optFilterCustom_cc").attr("checked", "checked");

					for (i = 0; i < optSettings.filters.length; i++) {
						var filterRow = $('.filterItem [type="checkbox"][value="' + optSettings.filters[i].filterId + '"]').closest('.filterItem');
						$(filterRow).find('.includeFilter').attr('checked', 'checked');
						$(filterRow).find('.allowCompare').attr('checked', isChartCreator ? true : optSettings.filters[i].compare);
						$(filterRow).find('.defaultDisplayed').attr('checked', optSettings.filters[i].defaultDisplayed);
					}
				} else if (isChartCreator) {
					$("#optFiltersAll_cc").attr("checked", "checked");
					$('.filterItem [type="checkbox"]').attr('checked', 'checked');
				} else {
					$("#optFilterCustom_cc").attr("checked", "checked");
				}

				if (isChartCreator)
					$("#optFilterAll_cc").closest(".allVsCustom_ct").next(".settingItem").toggle(!$("#optFilterAll_cc").is(":checked"));

				$('.filterItem [type="checkbox"], input[name="optFilter_cc"]').removeAttr('wasChanged');
				$('.filterItem [type="checkbox"], input[name="optFilter_cc"]').unbind('click').bind('click', function () { $(this).attr('wasChanged', true); });
				break;
			case Storyboard.ChartLab.parts[2]:
				// Time selections
				$(".chbTimePeriodEnabled input").removeAttr("checked");
				$(".rbDefaultTimePeriod input").removeAttr("checked").attr("disabled", "disabled");

				$('[id*=chblMovingAverage] [type="checkbox"]').removeAttr('checked');

				$(".chbIntervalEnabled input").removeAttr("checked");
				$(".rbDefaultInterval input").removeAttr("checked").attr("disabled", "disabled");

				$("#txtDefaultStartDate").datepicker();
				$("#txtDefaultStopDate").datepicker();

				$("#tblTimePeriod tbody tr").each(function () {
					var id = $(this).find("#hidTimePeriodId").val();
					$(this).find('input[id^="chbTimePeriodEnabled"]').attr('id', 'chbTimePeriodEnabled' + id);
					$(this).find('label[for^="chbTimePeriodEnabled"]').attr('for', 'chbTimePeriodEnabled' + id);
				});

				$("#tblIntervals tbody tr").each(function () {
					var id = $(this).find("#hidIntervalId").val();
					$(this).find('input[id^="chbIntervalEnabled"]').attr('id', 'chbIntervalEnabled' + id);
					$(this).find('label[for^="chbIntervalEnabled"]').attr('for', 'chbIntervalEnabled' + id);
				});

				$("#tblDateVariables tbody tr").each(function () {
					var id = $(this).find("#hidDateVariableId").val();
					$(this).find('input[id^="chbDateVariableEnabled"]').attr('id', 'chbDateVariableEnabled' + id);
					$(this).find('label[for^="chbDateVariableEnabled"]').attr('for', 'chbDateVariableEnabled' + id);
				});

				if (optSettings) {
					for (i = 0; i < optSettings.timePeriods.length; i++) {
						$("#tblTimePeriod tbody tr").each(function () {
							if ($(this).find("#hidTimePeriodId").val() == optSettings.timePeriods[i]) {
								$(this).find('input[id^="chbTimePeriodEnabled"]').attr("checked", "checked");
								$(this).find("#rbDefaultTimePeriod").removeAttr("disabled");
							}
						});
					}

					for (i = 0; i < optSettings.movingAverages.length; i++)
						$('[id*=chblMovingAverage] [type="checkbox"][value="' + optSettings.movingAverages[i] + '"]').attr('checked', 'checked');

					for (i = 0; i < optSettings.timeIntervals.length; i++) {
						$("#tblIntervals tbody tr").each(function () {
							if ($(this).find("#hidIntervalId").val() == optSettings.timeIntervals[i]) {
								$(this).find('input[id^="chbIntervalEnabled"]').attr("checked", "checked");
								$(this).find("#rbDefaultInterval").removeAttr("disabled");
							}
						});
					}

					if (optSettings.defaultTimeSelections) {
						$("#tblTimePeriod tbody tr").each(function () {
							if ($(this).find("#hidTimePeriodId").val() == optSettings.defaultTimeSelections.period)
								$(this).find("#rbDefaultTimePeriod").attr("checked", "checked");
						});

						$("#tblIntervals tbody tr").each(function () {
							if ($(this).find("#hidIntervalId").val() == optSettings.defaultTimeSelections.interval)
								$(this).find("#rbDefaultInterval").attr("checked", "checked");
						});

						$("#txtDefaultStartDate").datepicker("setDate", Helpers.parseDate(optSettings.defaultTimeSelections.strStartDate));
						$("#txtDefaultStopDate").datepicker("setDate", Helpers.parseDate(optSettings.defaultTimeSelections.strStopDate));

						$(".txtDefaultPeriodSpanAmount").val(optSettings.defaultTimeSelections.timePeriodSpanAmount || 1);
						$(".ddlDefaultPeriodSpan").val(optSettings.defaultTimeSelections.timePeriodSpan || 1);
					}
					if (optSettings.dateVariables.length > 0) {
						const dateVariableIds = new Set(optSettings.dateVariables.map(dv => dv.dateVariableId));
						const defaultDateVariableId = optSettings.dateVariables.find(dv => dv.isDefault)?.dateVariableId;

						$(".rbDefaultDateVariable input").removeAttr("checked").attr("disabled", "disabled");

						$("#tblDateVariables tbody tr").each(function () {
							const $row = $(this);
							const dateVariableId = parseInt($row.find("#hidDateVariableId").val());

							if (dateVariableIds.has(dateVariableId)) {
								$row.find('input[id^="chbDateVariableEnabled"]').attr("checked", "checked");
								$row.find("#rbDefaultDateVariable").removeAttr("disabled").attr("checked", dateVariableId == defaultDateVariableId);
							}
						});
					} else if (singleObjectMode) {
						$(".chbDateVariableEnabled input").attr("checked", "checked");
						$(".rbDefaultDateVariable input").removeAttr("disabled");
					}
				}
					else if (singleObjectMode) {
					$('[id*=chblMovingAverage] [type="checkbox"]').attr('checked', 'checked');

					$(".chbTimePeriodEnabled input").attr("checked", "checked");
					$(".rbDefaultTimePeriod input").removeAttr("disabled");
					$(".rbDefaultTimePeriod input", $("#hidTimePeriodId[value='20']").closest("tr")).attr("checked", "checked");

					$(".chbIntervalEnabled input").attr("checked", "checked");
					$(".rbDefaultInterval input").removeAttr("disabled");
					$(".rbDefaultInterval input", $("#hidIntervalId[value='7']").closest("tr")).attr("checked", "checked");


					$(".chbDateVariableEnabled input").attr("checked", "checked");
					$(".rbDefaultDateVariable input").removeAttr("disabled");
				}

				$("#chblMovingAverage").css("display", isChartCreator ? "none" : "");
				$("#chbMovingAverage_cc").parent().css("display", isChartCreator ? "" : "none");
				if (optSettings && optSettings.movingAverages.length < 1)
					$("#chbMovingAverage_cc").removeAttr("checked");
				else
					$("#chbMovingAverage_cc").attr("checked", "checked");

				$("#tblTimePeriod tbody tr").each(function () {
					if ($(this).find("#hidTimePeriodId").val() != 0)
						$(".optDefaultStartStop", this).remove();

					if ($(this).find("#hidTimePeriodId").val() != 27)
						$(".optDefaultTimeSpans", this).remove();
				});

				$(".optDefaultStartStop").toggle($("#hidTimePeriodId", $(".rbDefaultTimePeriod input:checked").first().closest("tr")).val() == 0);
				$(".optDefaultTimeSpans").toggle($("#hidTimePeriodId", $(".rbDefaultTimePeriod input:checked").first().closest("tr")).val() == 27);

				break;
			case Storyboard.ChartLab.parts[3]:
				// Series
				$('input[name="chbObjectTypeGroup"][type="checkbox"]').removeAttr('checked');
				$('input[name="chbCTypeGroup"][type="checkbox"]').removeAttr('checked');
				$('input[name="chbSeriesOptionGroup"][type="checkbox"]').removeAttr('checked');

				if (optSettings) {
					for (i = 0; i < optSettings.objectTypes.length; i++)
						$('input[name="chbObjectTypeGroup"][type="checkbox"][value="' + optSettings.objectTypes[i] + '"]').attr('checked', 'checked');

					for (i = 0; i < optSettings.seriesTypes.length; i++)
						$('input[name="chbCTypeGroup"][type="checkbox"][value="' + optSettings.seriesTypes[i] + '"]').attr('checked', 'checked');

					for (i = 0; i < optSettings.seriesAttributes.length; i++)
						$('input[name="chbSeriesOptionGroup"][type="checkbox"][value="' + optSettings.seriesAttributes[i] + '"]').attr('checked', 'checked');

					$("#chbPolarCharts_optCc").attr("checked", optSettings.enablePolar);
				} else if (isChartCreator) {
					$('input[name="chbObjectTypeGroup"][type="checkbox"]').attr('checked', 'checked');
					$('input[name="chbCTypeGroup"][type="checkbox"]').attr('checked', 'checked');
					$('input[name="chbSeriesOptionGroup"][type="checkbox"]').attr('checked', 'checked');
					$("#chbPolarCharts_optCc").attr("checked", "checked");
				}

				if ($('input[name="chbObjectTypeGroup"]:checked').length === 1)
					$('input[name="chbObjectTypeGroup"]:checked').attr('disabled', 'disabled');
				else
					$('input[name="chbObjectTypeGroup"]').removeAttr('disabled');

				if (isChartCreator) {
					$("input[name='chbCTypeGroup'][value='10'], input[name='chbCTypeGroup'][value='11']").closest('tr').hide();
					$("#trEnablePolar_cc").show();
				} else
					$("#trEnablePolar_cc").hide();
				break;
			case Storyboard.ChartLab.parts[5]:
				// CT Weighting
				$("#tblWeights tbody tr").each(function () {
					var id = $(this).find("#hidWeightVariableId").val();
					$(this).find('input[id^="chbWeightVariableEnabled"]').attr('id', 'chbWeightVariableEnabled' + id);
					$(this).find('label[for^="chbWeightVariableEnabled"]').attr('for', 'chbWeightVariableEnabled' + id);
				});
				if (optSettings) {
					$("#chbWeightedResult_optCt").attr("checked", optSettings.weightedResult);
					$("#chbUnweightedResult_optCt").attr("checked", optSettings.unweightedResult);

					if (optSettings.weightVariables.length > 0) {
						$(".rbDefaultWeightVariable input").removeAttr("checked").attr("disabled", "disabled");
						const weightIds = new Set(optSettings.weightVariables.map(w => w.weightId));
						const defaultWeightId = optSettings.weightVariables.find(w => w.isDefault)?.weightId;

						$("#tblWeights tbody tr").each(function () {
							const $row = $(this);
							const weightId = parseInt($row.find("#hidWeightVariableId").val());

							if (weightIds.has(weightId)) {
								$row.find('input[id^="chbWeightVariableEnabled"]').attr("checked", "checked");
								$row.find("#rbDefaultWeightVariable").removeAttr("disabled").attr("checked", weightId == defaultWeightId);		
							}
						});
					} else if (singleObjectMode) {
						$(".chbWeightVariableEnabled input").attr("checked", "checked");
						$(".rbDefaultWeightVariable input").removeAttr("disabled");
					}
				} else if (singleObjectMode) {
					$(".chbWeightVariableEnabled input").attr("checked", "checked");
					$(".rbDefaultWeightVariable input").removeAttr("disabled");
				}
				break;
			case Storyboard.ChartLab.parts[6]:
				// Base size limits

				$("#tblHideLimitsMain_optCt tbody tr").each(function () {
					var id = $(this).find("#hidHideLimitId").val();
					$(this).find('input[id^="chbHideLimitEnabled"]').attr('id', 'chbHideLimitEnabled' + id);
					$(this).find('label[for^="chbHideLimitEnabled"]').attr('for', 'chbHideLimitEnabled' + id);
					$(this).find('input[id^="rbHideLimitDefault"]').attr('id', 'rbHideLimitDefault' + id).attr('value', id).attr('name', 'rbHideLimitDefault');
				});

				$("#tblWarnLimitsMain_optCt tbody tr").each(function () {
					var id = $(this).find("#hidWarnLimitId").val();
					$(this).find('input[id^="chbWarnLimitEnabled"]').attr('id', 'chbWarnLimitEnabled' + id);
					$(this).find('label[for^="chbWarnLimitEnabled"]').attr('for', 'chbWarnLimitEnabled' + id);
					$(this).find('input[id^="rbWarnLimitDefault"]').attr('id', 'rbWarnLimitDefault' + id).attr('value', id).attr('name', 'rbWarnLimitDefault');
				});

				$('.rbHideLimitDefault input:not([value="0"])').attr("disabled", "disabled");
				$('.rbWarnLimitDefault input:not([value="0"])').attr("disabled", "disabled");

				if (optSettings && optSettings.trimSettings) {
					var trimSettings = optSettings.trimSettings;
					$("#chbTrimLowResult_optCt").attr("checked", trimSettings.trimLowResultEnabled);
					$("#chbTrimLowResultShow_optCt").attr("checked", trimSettings.trimLowResultVisible);
					$("#txtTrimLowResultValue_Optct").val(trimSettings.trimLowResultValue);
					$("#ddlTrimLowResultType_optCt").val(trimSettings.trimLowResultType || 1);

					$("#chbTrimLowBase_optCt").attr("checked", trimSettings.trimLowBaseEnabled);
					$("#chbTrimLowBaseShow_optCt").attr("checked", trimSettings.trimLowBaseVisible);
					$("#txtTrimLowBaseValue_Optct").val(trimSettings.trimLowBaseValue);
					$("#ddlTrimLowBaseType_optCt").val(trimSettings.trimLowBaseType || 1);

					$(".chbHideLimitEnabled input").removeAttr("checked");
					$(".rbHideLimitDefault input").removeAttr("checked").attr("disabled", "disabled");
					
					var availableBaseSizeHideLimitIds = trimSettings.availableBaseSizeHideLimitIds ? trimSettings.availableBaseSizeHideLimitIds.split(',') : [];
					availableBaseSizeHideLimitIds.forEach(function(id) {
						$('#chbHideLimitEnabled' + id).attr('checked', true);
						$('#rbHideLimitDefault' + id).removeAttr('disabled');
					});

					$('#rbHideLimitDefault' + trimSettings.baseSizeHideLimitId).attr('checked', true);

					toggleCustomHideLimit();

					$("#chbWarnLowBase_optCt").attr("checked", trimSettings.warnLowBaseEnabled);
					$("#chbWarnLowBaseShow_optCt").attr("checked", trimSettings.warnLowBaseVisible);
					$("#txtWarnLowBaseValue_Optct").val(trimSettings.warnLowBaseValue);
					$("#ddlWarnLowBaseType_optCt").val(trimSettings.warnLowBaseType || 1);

					$(".chbWarnLimitEnabled input").removeAttr("checked");
					$(".rbWarnLimitDefault input").removeAttr("checked").attr("disabled", "disabled");
					
					var availableBaseSizeWarningLimitIds = trimSettings.availableBaseSizeWarningLimitIds ? trimSettings.availableBaseSizeWarningLimitIds.split(',') : [];
					availableBaseSizeWarningLimitIds.forEach(function(id) {
						$('#chbWarnLimitEnabled' + id).attr('checked', true);
						$('#rbWarnLimitDefault' + id).removeAttr('disabled');
					});

					$('#rbWarnLimitDefault' + trimSettings.baseSizeWarningLimitId).attr('checked', true);

					toggleCustomWarnLimit();
				}
				break;
			case Storyboard.ChartLab.parts[7]:
				// Optional
				if (optSettings) {
					$("#chbComputeVariables_ct").attr("checked", optSettings.enableComputes);
					$("#chbFormattingRules_ct").attr("checked", optSettings.enableFormattingRules);

					$('input.deckAccessMode').removeAttr('checked');
					$('input.deckAccessMode[value="' + optSettings.deckAccessType + '"]').attr('checked', 'checked');

					$('#chbEnableDeckFilters_cc').attr('checked', optSettings.enableDeckFilters);
				}

				$('#chbClipboard_cc').closest('.settingsFieldsetContent').toggle(isChartCreator);
				$('.trDeckAccess_cc, .divDeckFilters_cc').toggle(isChartCreator);
				if (isChartCreator) {
					$('#chbClipboard_cc').attr('checked', optSettings ? optSettings.enableClipboard : true);
					bindSharingOptions(optSettings);
				}
				break;
			case Storyboard.ChartLab.parts[12]:
				// Smart functions
				if (optSettings) {
					$("#chbSmartPositioning").attr("checked", optSettings.applySmartPositioning);
					$("#chbChartTypeRecommendations").attr("checked", optSettings.enableRecommendations);
				}
				break;
			case Storyboard.ChartLab.parts[13]:
				// Layout templates
				if (optSettings && optSettings.layoutSettings) {
					$("#chbEnableLayoutTemplates").attr("checked", optSettings.layoutSettings.enableLayoutTemplates);
					$("#chbEnableMasterSlideLayout").attr("checked", optSettings.layoutSettings.enableMasterSlideLayout);
					$("#masterLayoutFileName").text(optSettings.layoutSettings.masterLayoutFileName);
					Storyboard.LayoutDesigner.initMasterLayoutFileName = optSettings.layoutSettings.masterLayoutFileName;
					$("#divMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId").val(optSettings.layoutSettings.defaultMasterLayoutId);
					$("#txtLayoutMarginLeft").val(optSettings.layoutSettings.marginLeft);
					$("#txtLayoutMarginRight").val(optSettings.layoutSettings.marginRight);
					$("#txtLayoutMarginTop").val(optSettings.layoutSettings.marginTop);
					$("#txtLayoutMarginBottom").val(optSettings.layoutSettings.marginBottom);
					$("#txtLayoutMarginBetween").val(optSettings.layoutSettings.marginBetween);
					$('#txtSlideTitleHeight').val(optSettings.layoutSettings.slideTitleHeight);
					$('#txtSlideSubtitleHeight').val(optSettings.layoutSettings.slideSubtitleHeight);
					$('#txtSlideFooterHeight').val(optSettings.layoutSettings.slideFooterHeight);
					$("#btnMasterLayoutFileDownload").removeAttr('disabled');
					$("#masterLayoutFileDownload").show();
					loadMasterLayoutThumbnailsInfo();
				}

				Helpers.setupNumericTextbox(".txtLayoutMargins");
				setupLayoutTemplatesValidations();
				showHideLayoutSettings();
				break;

			case Storyboard.ChartLab.parts[14]:
				// Color categories
				if (optSettings) {
					if (optSettings.allColorCategories) $("#optColorsAll_cc").attr("checked", "checked");
					else $("#optColorsCustom_cc").attr("checked", "checked");

					$('input.colorCatInclude_cc[type="checkbox"]').removeAttr('checked');
					for (i = 0; i < optSettings.colorCategories.length; i++) {
						$('input.colorCatInclude_cc[type="checkbox"][value="' + optSettings.colorCategories[i].colorCategoryId + '"]').attr('checked', 'checked');
					}
				}

				$("#optColorsAll_cc").closest(".allVsCustom_ct").next(".settingItem").toggle(!$("#optColorsAll_cc").is(":checked"));
				break;
			case Storyboard.ChartLab.parts[15]:
				$('#tblStaticFilters > tbody > tr:not(.staticFilterRowTemplate)').remove();
				if (optSettings) {
					$('.hideStaticFilters').toggle(optSettings.staticFilters.length > 0);
					$('#chbHideStaticFiltersInfo').attr('checked', optSettings.hideStaticFiltersInfo);
					$(optSettings.staticFilters).each(function () { Storyboard.ChartLab.Setup.addStaticFilterRow(this); });
				}
				$('#tblStaticFilters').removeAttr('wasChanged');
				break;
			case Storyboard.ChartLab.parts[16]:
				if (optSettings) {
					$('#chbFavorites_ct').attr('checked', optSettings.enableFavorites);
					$('#chbWorkbooks_ct').attr('checked', optSettings.enableWorkbooks);
				} else {
					$('#chbFavorites_ct').attr('checked', useCtFavoritesByDefault);
					$('#chbWorkbooks_ct').attr('checked', !useCtFavoritesByDefault);
				}

				$('#chbClipboard_ct').attr('checked', optSettings ? optSettings.enableClipboard : true);
				$('#chbFavorites_ct').removeAttr('disabled');
				$('#saveFavesDisabledHelp_ct').hide();
				if (optSettings && !optSettings.enableFavorites)
					CrossTable2DataCom.GetHasWorkbooks(function (hasWorkbooks) {
						if (hasWorkbooks) {
							$('#chbFavorites_ct').attr('disabled', 'disabled');
							$('#saveFavesDisabledHelp_ct').show();
						}
					});
				bindSharingOptions(optSettings);
				break;

			case Storyboard.ChartLab.parts[18]: // Table key
				var tableKeys = optSettings ? optSettings.tableKeys : 91; // 91 is default - time period, filter text, bm, sig test and correlation
				$('input.tableKeyItem').removeAttr('checked');
				$('input.tableKeyItem').each(function () {
					var val = parseInt($(this).val() || 0, 10);
					if ((val & tableKeys) == val) {
						$(this).attr('checked', true);
					}
				});
				break;
			case Storyboard.ChartLab.parts[19]: //Export Options
				if (optSettings) {
					$('#chbGoogleSheetsExport').attr('checked', optSettings.googleSheetsExport);
				}
				break;
			case Storyboard.ChartLab.parts[20]: // Base
				if (optSettings) {
					$("#chbWeightedBase_ct").attr("checked", optSettings.weightedBase);
					$("#chbUnweightedBase_ct").attr("checked", optSettings.unweightedBase);
					$("#chbEffectiveBase_ct").attr("checked", optSettings.effectiveBase);
				}
		}
	}

	function bindSharingOptions(optSettings) {
		if (optSettings) {
			$('#chbSharedFavorites').attr('checked', optSettings.enableSharedFavorites);
			$('#chbEnableCollaboration').attr('checked', optSettings.enableCollaboration);

			$('input.faveSharingType').removeAttr('checked');
			$('#chbShareWithIndividual').removeAttr('checked');
			$('input.faveSharingType').each(function () {
				var val = parseInt($(this).val() || 0, 10);
				if ((val & optSettings.favoriteSharingType) == val) {
					$(this).attr('checked', true);
					if (val == Storyboard.Constants.FavoriteSharingType.IndividualUsersWithinGroup || val == Storyboard.Constants.FavoriteSharingType.AllIndividualUsers)
						$('#chbShareWithIndividual').attr('checked', true);
					else if (val == Storyboard.Constants.FavoriteSharingType.OwnGroup || val == Storyboard.Constants.FavoriteSharingType.AllGroups)
						$('#chbShareWithGroup').attr('checked', true);
				}
			});
		} else {
			if (isDeckSharingDisabledByDefault)
				$('#chbSharedFavorites').removeAttr('checked');
			if (ctNoUserSharingByDefault)
				$('#chbShareWithIndividual').removeAttr('checked');
			if (collaborationDisabledByDefault)
				$('#chbEnableCollaboration').removeAttr('checked');
		}

		toggleSharing();
	}

	function closeCustomSettings(isBeforeCloseCall) {
		if (isBeforeCloseCall === undefined && (!checkIsCalcSelected() || !isAnyWeightChecked() ||!isAnyDateChecked())) {
			return;
		}
		var vSettings = $('#setupOptionalChartSettings');
		vSettings.hide();
		if (Storyboard.LayoutDesigner.isAdmin && (!Helpers.isPreview() || window.ContentType > 0)) {
			$('#setupWordCloudTab > div:first').after(vSettings);
		}
	}
	
    function showHideFieldset(fieldset, show) {
        if (show) {
            fieldset.show();
        } else {
            fieldset.hide();
        }
    }

	function bindQuestions(optSettings) {
        ChartSetupProxy.GetFilterQuestions("", "", "", "", "", false, "", 0, false, function (questions) {
            $(questions).each(function () {
                var newRow = '<tr class="qnItem">' +
								'<td>' + HTMLHelpers.htmlEncode(this.code) + '</td>' +
								'<td>' + this.questionText + '</td>' +
								'<td>' + this.questionTypeName + '</td>' +
								'<td>' + HTMLHelpers.htmlEncode(this.answerBlockText) + '</td>' +
								'<td style="text-align:center"><input type="checkbox" value="' + this.questionId + '" /></td>' +
							'</tr>';
                $("#tblQns > tbody:last").append(newRow);
			});

			Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(Storyboard.ChartLab.parts[0], optSettings);

			if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
				var filterQuestions = questions.filter(function (question) {
					return !question.isIndexed && !question.isCompute &&
						(question.questionT === 1 ||
							question.questionT === 2 ||
							question.questionT === 3);
				});
				var ddl = $('#tblStaticFilters > tbody > tr:first select.ddlStaticFilterQuestion');
				HTMLHelpers.bindSelect(ddl, filterQuestions, 'questionId', 'questionText', ' ', false, -1, false);

				Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(Storyboard.ChartLab.parts[15], optSettings);
			}

			if (optSettings === null) {
				Storyboard.ChartLab.Setup.optionalSettings = Storyboard.ChartLab.Setup.getCustomSettingsFromGui();
			}
        });
    }

    function bindFilters(optSettings) {
        ChartSetupProxy.GetFilters(function (filters) {
            $(filters).each(function () {
                var newRow = '<tr class="filterItem">' +
								'<td>' + this.filterText + '</td>' +
								'<td style="text-align:center"><input class="includeFilter" type="checkbox" value="' + this.filterId + '" /></td>' +
								'<td class="allowCompareTd" style="text-align:center"><input class="allowCompare" type="checkbox" /></td>' +
                                '<td style="text-align:center; display:none"><input class="defaultDisplayed" type="checkbox" /></td>' +
							'</tr>';
				$("#tblFilters > tbody:last").append(newRow);
			});

			Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(Storyboard.ChartLab.parts[1], optSettings);

			if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
				$('#tblFilters .allowCompareTd').hide();

				var ddl = $('#tblStaticFilters > tbody > tr:first select.ddlStaticFilterQuestion');
				HTMLHelpers.bindSelect(ddl, filters, 'questionId', 'filterText', ' ', false, -1, false, ["filterId"]);

				Storyboard.ChartLab.Setup.setOptionalChartSettingsForPart(Storyboard.ChartLab.parts[15], optSettings);
			}

			if (optSettings === null) {
				Storyboard.ChartLab.Setup.optionalSettings = Storyboard.ChartLab.Setup.getCustomSettingsFromGui();
			}
        });
	}

	function createCategoriesTable(template) {
		$('#hidColorTemplateId').val(template.id);

		if (template.categories) {
			template.categories.forEach(function(category) {
				if (category.isStandardPalette)
					return;

				var colors = '';
				$(category.colors).each(function () {
					var color = category;
					var colorValues = tinycolor({ r: color.r, g: color.g, b: color.b });
					var colorString = colorValues.toRgbString();

					if (color.a === 0) {
						colors += '<div class="colorpicker-palette-color color-transparent" data-id="' + color.id + '"' +
							'style="color: transparent" title="' + (color.tags || 'transparent') + '">' +
							'</div>';
					} else {
						colors += '<div class="colorpicker-palette-color" data-id="' + color.id + '"' +
							'style="color: ' + colorString + '" title="' + (color.tags || colorString) + '">' +
							'</div>';
					}
				});

				var newRow =
					'<tr class="categoryRow">' +
						'<td style="text-align:center"><input type="checkbox" class="colorCatInclude_cc" value="' + category.id + '" checked="checked" /></td>' +
						'<td>' + category.name + '</td>' +
						'<td>' + colors + '</td>' +
					'</tr>';

				$("#tableCategories_cc > tbody:last").append(newRow);
			});
		}
	}

	function addStaticFilterRow(filter) {
		var newRow = $('#tblStaticFilters > tbody > tr.staticFilterRowTemplate:first').clone().removeClass('staticFilterRowTemplate').show();
		$('#tblStaticFilters > tbody').append(newRow);

		var filterQnDdl = $('select.ddlStaticFilterQuestion', newRow);
		$('select.ddlStaticFilterOption', newRow)
			.multiselect({
				multiple: true,
				header: false,
				maxWidth: 400,
				selectedList: 3,
				classes: 'ChartCreator-multiselect ChartCreator-multiselect-static-filter',
				appendTo: '#setupOptionalChartSettings'
			});

		if (filter) {
			filterQnDdl.val(filter.questionId ?? -1);
			Storyboard.ChartLab.Setup.loadStaticFilterAnswers(filterQnDdl, filter.answerIds);
		}

		$('button.deleteStaticFilter', newRow).bind('click', function () {
			$(this).closest('tr').remove();
			if ($('#tblStaticFilters > tbody > tr:not(.staticFilterRowTemplate)').length < 1) {
				$('#tblStaticFilters').hide();
				$('.hideStaticFilters').hide();
			}
			$('#tblStaticFilters').attr('wasChanged', true);
		});
		filterQnDdl.bind('change', function () {
			Storyboard.ChartLab.Setup.loadStaticFilterAnswers(this);
			$('#tblStaticFilters').attr('wasChanged', true);
		});

		$('#tblStaticFilters').attr('wasChanged', true);
		$('#tblStaticFilters').show();
		$('.hideStaticFilters').show();
	}

	function loadStaticFilterAnswers(filterDdl, selectedAnswers) {
		var selections = {
			filter: '',
			selectedQuestions: [$(filterDdl).val()],
			variableSubsets: [],
			calculationType: 1,
			filterByRowNo: false
		};
		ChartSetupProxy.GetAnswers(selections, function (answers) {
			var ddl = $(filterDdl).closest('tr').find('select.ddlStaticFilterOption');
			HTMLHelpers.bindSelect(ddl, answers, 'answerId', 'answerText', false, false, false, false);
			if (selectedAnswers)
				HTMLHelpers.setSelectedValues(ddl, selectedAnswers);
			$(ddl).multiselect('refresh');
		});
	}

	function toggleCustomWarnLimit() {
		var isCustom = $("#rbWarnLimitDefault0").is(':checked');
		$('#txtWarnLowBaseValue_Optct').closest('.settingItem').toggle(isCustom);
	}

	function toggleCustomHideLimit() {
		var isCustom = $("#rbHideLimitDefault0").is(':checked');
		$('#txtTrimLowBaseValue_Optct').closest('.settingItem').toggle(isCustom);
	}

	function bindEvents() {
		$("#tblWarnLimitsMain_optCt .rbWarnLimitDefault input")
			.unbind("change.toggleCustomWarnLimit")
			.bind("change.toggleCustomWarnLimit", toggleCustomWarnLimit);
		$("#tblHideLimitsMain_optCt .rbHideLimitDefault input")
			.unbind("change.toggleCustomWarnLimit")
			.bind("change.toggleCustomWarnLimit", toggleCustomHideLimit);

		$('#chbFavorites_ct, #chbWorkbooks_ct').unbind('change').bind('change', function () {
			function setFaveVsWb(box) {
				$($(box).attr('id') == 'chbFavorites_ct' ? '#chbWorkbooks_ct' : '#chbFavorites_ct').removeAttr('checked');
				toggleSharing();
			}

			var faveOrWbBox = $(this);
			if (faveOrWbBox.is(':checked')) {
				if ($(this).attr('id') === 'chbWorkbooks_ct') {
					CrossTable2DataCom.GetHasFavorites(function (hasFavorites) {
						if (hasFavorites)
							new DUIwindow2({
								closeButton: false,
								width: 340,
								height: 'auto',
								html: '<b>Note</b>: this report contains saved Favorites. When Workbooks are enabled, all Favorites are converted to Workbooks with a single sheet.\r\n' +
									'All Favorites are lost. It will not be possible to enable Favorites again unless all saved Workbooks are manually deleted.',
								buttons: [{
									text: locale.get("Continue"),
									onClick: function () {
										setFaveVsWb(faveOrWbBox);
									}
								},{
									text: locale.get("Cancel"), focused: true,
									onClick: function () { $(faveOrWbBox).removeAttr('checked', 'checked'); }
								}]
							});
						else
							setFaveVsWb(faveOrWbBox);
					});
				} else {
					CrossTable2DataCom.GetHasWorkbooks(function (hasWorkbooks) {
						if (hasWorkbooks) {
							$('#chbFavorites_ct').removeAttr('checked').attr('disabled', 'disabled');
							$('#saveFavesDisabledHelp_ct').show();
						} else
							setFaveVsWb(faveOrWbBox);
					});
				}
			} else
				toggleSharing();
		});
		$('input.deckAccessMode').unbind('change').bind('change', function () {
			if ($(this).is(':checked'))
				$($(this).attr('id') == 'optCreateAndUpdate_cc' ? '#optNoUpdates_cc' : '#optCreateAndUpdate_cc').removeAttr('checked');
			toggleSharing();
		});
		$('#chbSharedFavorites').unbind('change').bind('change', toggleSharingOptions);

		$('#chbShareWithIndividual, #chbShareWithGroup, input.faveSharingType').unbind('change').bind('change', onSharingTypeChanged);

		$('#chbEnableLayoutTemplates').unbind('change').bind('change', function() {
			$('#chbEnableMasterSlideLayout').attr('checked', !$(this).is(':checked'));
			showHideLayoutSettings();
		});

		$('#chbEnableMasterSlideLayout').unbind('change').bind('change', function() {
			$('#chbEnableLayoutTemplates').attr('checked', !$(this).is(':checked'));
			showHideLayoutSettings();

			if ($(this).is(':checked')) {
				if ($('#divMasterLayoutSettingsWrapper .master-layouts > .master-layout').length === 0) {
					$('#divMasterLayoutSettingsWrapper .master-layout-upload').show();
					$('#divMasterLayoutSettingsWrapper .master-layout-preview').hide();
				} else {
					$('#divMasterLayoutSettingsWrapper .master-layout-upload').hide();
					$('#divMasterLayoutSettingsWrapper .master-layout-preview').show();
				}
			}
		});

		$('#inputMasterLayoutUpload, #inputMasterLayoutChange').unbind('change').bind('change', onMasterLayoutUploadChange);
		$('#inputMasterLayoutChange').unbind('click').bind('click', onMasterLayoutUploadClick);
		$('#btnMasterLayoutFileDownload').unbind('click').bind('click', onMasterLayoutFileDownloadClick);

		$('#masterLayoutUploadArea').unbind('dragenter dragleave dragover drop');

		$('#masterLayoutUploadArea').bind('dragenter dragleave dragover drop', preventDefaults);
		$('#masterLayoutUploadArea').bind('dragenter dragover', uploadAreaHighlight);
		$('#masterLayoutUploadArea').bind('dragleave drop', uploadAreaUnhighlight);
		$('#masterLayoutUploadArea').bind('drop', onMasterLayoutUploadAreaDrop);

		$('#divMasterLayoutSettingsWrapper .master-layouts').undelegate('click').delegate('.master-layout', 'click', onMasterLayoutThumbnailClick);

		$('#layoutMasterTemplateShowInfo').unbind('click').bind('click', function () { 
			var html =
				'<h2>Layout master templates</h2>'+
				'<p>With Layout master templates you can upload your own corporate designed PPT Master template to your StoryCreator which makes the process of deck creation more efficient. Just as in PowerPoint you can select any available slide layout template to start off with when creating a new slide.</p>'+
				'<p>The different placeholders added to your Master templates will be mimicked and added as native Dapresy objects to your slide, and positioned in the same way as in your Master template.</p>'+
				'<p>Placeholders for text boxes; font (if existing), size and colors will be applied by default.<br/>'+
				'Placeholders for Tables, Charts and Images will be added automatically.<br/>'+
				'Other placeholders in your Master template, like video and smart art placeholders, will be treated as multi objects.</p>'+
				'<p>If other objects, non placeholders, is added to your Master template, such as images, text, icons, these will be shown as a visible background in your slide.</p>'+
				'<p>If you have regular PPT slides in your PPT Master template while uploading it, these slides will be exported before your StoryCreator deck slides.</p>';

			new DUIwindow2({
				title: "",
				width: 510,
				padding: 45,
				buttonsHeight: 50,
				buttons: [],
				html: html,
				modal: true,
				preWrapSpace: false
			});
		});

		

		$('#PPTTemplateShowInfo').unbind('click').bind('click', function () { 
			var html = 
				'<h2>PPT template</h2>'+
				'<p>If you change this option it will be saved automatically, even if "Cancel" button is pressed afterward.</p>';

			new DUIwindow2({
				title: "",
				width: 510,
				padding: 45,
				buttonsHeight: 50,
				buttons: [],
				html: html,
				modal: true,
				preWrapSpace: false
			});
		});

		$('#imageQualityShowInfo').unbind('click').bind('click', function () { 
			var html = 
				'<h2>Image quality</h2>'+
				'<p>If you change any of image quality options they will be saved automatically, even if "Cancel" button is pressed afterward.</p>';

			new DUIwindow2({
				title: "",
				width: 510,
				padding: 45,
				buttonsHeight: 50,
				buttons: [],
				html: html,
				modal: true,
				preWrapSpace: false
			});
		});
	}

	function showHideLayoutSettings() {
		var enableLayoutTemplates = $("#chbEnableLayoutTemplates").is(":checked");
		var enableMasterSlideLayout = $("#chbEnableMasterSlideLayout").is(":checked");

		$('#divLayoutTemplatesSettingsWrapper').toggle(enableLayoutTemplates);
		$('#divMasterLayoutSettingsWrapper').toggle(enableMasterSlideLayout);
		$('#divMasterLayoutSettingsWrapper').parent().toggle(enableLayoutTemplates || enableMasterSlideLayout);
		$('#sfCustomExportTemplatesContainer').toggle(enableLayoutTemplates);
	}

	function preventDefaults(event) {
		event.preventDefault();
		event.stopPropagation();
	}

	function uploadAreaHighlight(event) {
		$('#masterLayoutUploadArea').addClass('drag-active');
	}

	function uploadAreaUnhighlight(event) {
		$('#masterLayoutUploadArea').removeClass('drag-active');
	}

	function onMasterLayoutUploadAreaDrop(event) {
		var dt = event.originalEvent.dataTransfer;
		var file = dt.files[0];

		if (file) {
			uploadMasterLayoutFile(file);
		}
	}

	function onMasterLayoutUploadChange(event) {
		var data = event.target.files[0];

		if (data) {
			uploadMasterLayoutFile(data);
		}
	}

	function onMasterLayoutUploadClick(event) {
		if ($('.confirm-master-layout-change').length === 0) {
			event.preventDefault();
		} else {
			return;
		}

		new DUIwindow2({
			closeButton: false,
			width: 680,
			height: 'auto',
			title: '<h2>Change Master slide PPT</h2>',
			html: '<p class="Message Message-warning">When you upload a new Slide Master, we will replace the "background" of all already saved slides. If there is a slide with identical name in the new Slide Master, we will replace the previous "background" with this. If there is no slide with identical name, we will use the default slide as replacement. Please also note that once you have uploaded your new Slide Master, the previously used Slide Master will be removed directly and you can not go back to the previous one without uploading it again. There is no cancel feature for this, the update is immediate.</p>',
			cssClass: 'confirm-master-layout-change',
			buttons: [
				{
					text: locale.get("Cancel")
				},
				{
					text: locale.get("OK"),
					focused: true,
					onClick: function () {
						$(this.windowEl).removeClass('.confirm-master-layout-change');
						$('#inputMasterLayoutChange').trigger('click');
					}
				}
			]
		});
	}

	function onMasterLayoutFileDownloadClick() {
		var iframe = document.createElement("iframe");
		iframe.src = $('input[id$="hidBaseUrl"]').val() + '/Storyboard/FileHandler.ashx?downloadMasterLayoutFile=true';
		iframe.style.display = "none";
		document.body.appendChild(iframe);
	}

	function uploadMasterLayoutFile(file) {
		var baseUrl = $('input[id$="hidBaseUrl"]').val();
		var url = baseUrl + '/Storyboard/FileHandler.ashx?masterSlideLayout=true';
		var fileTypes = ['.ppt', '.pptx', '.pot', '.potx'];

		var fileName = file.name;
		var isFileTypeAccepted = fileName && fileTypes.some(function(fileType) { return fileName.endsWith(fileType); });
		
		if (!isFileTypeAccepted) {
			DUImessage.show('File must be PPT, PPTX, POT or POTX type.', 'Message-error', 5000);
			return;
		}

		var formData = new FormData();
		formData.append('myFile', file);

		var loadingBar = Storyboard.LayoutControls.showLoadingBar('Uploading master slide...');

		return $.ajax({
			type: 'POST',
			url: url,
			processData: false,
			contentType: false,
			data: formData,
			success: function (data, status, xhr) {
				if (status === 'success') {
					if (xhr.responseText && xhr.responseText.startsWith('DUPLICATES')) {
						Storyboard.LayoutControls.hideLoadingBar(loadingBar);
						const message = xhr.responseText.replace("DUPLICATES", "");
						DUImessage.show(message, 'Message-error', 5000);
						return;
					}
					var version = ChartCreatorSetup.getSlideMasterLayoutsVersion();
					ChartCreatorSetup.setSlideMasterLayoutsVersion(++version);

					$('#masterLayoutFileName').text(fileName);
					$("#btnMasterLayoutFileDownload").attr('disabled', 'disabled');
					$('#masterLayoutFileDownload').hide();
					$('#divMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId').val(null);
					$('#masterLayoutDefaultMessage').show();

					loadMasterLayoutThumbnailsInfo(true);
				}

				Storyboard.LayoutControls.hideLoadingBar(loadingBar);
				$('#inputMasterLayoutUpload, #inputMasterLayoutChange').val(null);
			},
			error: function (xhr, status, error) {
				var errObj = JSON.parse(xhr.responseText);
				Storyboard.LayoutControls.hideLoadingBar(loadingBar);
				Storyboard.LayoutControls.showError(errObj.Message || 'Unknown error occured');
				$("#inputMasterLayoutUpload, #inputMasterLayoutChange").val(null);
			}
		});
	}

	function loadMasterLayoutThumbnailsInfo(temporary) {
		var loadingBar = Storyboard.LayoutControls.showLoadingBar('Loading master slide layouts...');

		Helpers.perfJSonCall({
			method: temporary ? "GetTempMasterLayouts" : "GetMasterLayouts",
			service: 'ReportService',
			fixCasing: true,
			successCallback: function (layouts) {
				if (layouts.length > 0) {
					$('#divMasterLayoutSettingsWrapper .master-layout-upload').hide();
					$('#divMasterLayoutSettingsWrapper .master-layout-preview').show();
				} else {
					$('#divMasterLayoutSettingsWrapper .master-layout-upload').show();
					$('#divMasterLayoutSettingsWrapper .master-layout-preview').hide();
				}
				
				if (temporary) {
					setDocFormatSizeFromMasterLayout(layouts);
				}

				renderMasterLayoutThumbnails(layouts);

				Storyboard.LayoutControls.hideLoadingBar(loadingBar);
			},
			failedCallback: function () {
				Storyboard.LayoutControls.showMessage(locale.get('Unable to load master slide layouts'));
				Storyboard.LayoutControls.hideLoadingBar(loadingBar);
			}
		});
	}

	function setDocFormatSizeFromMasterLayout(layouts) {
		var formats = Storyboard.Constants.documentFormats;
		var firstMasterLayout = layouts[0];
		
		if (!firstMasterLayout) return;

		var matchedFormat = Object.keys(formats).find(function(key) {
			return formats[key].layoutWidth === firstMasterLayout.width && formats[key].layoutHeight === firstMasterLayout.height;
		});

		if (matchedFormat) {
			$("#ddlReportDocFormat").val(formats[matchedFormat].hash);
		} else {
			$("#ddlReportDocFormat").val(formats['CUSTOM'].hash);
			$("#txtCustomSlideSizeWidth").val(firstMasterLayout.width);
			$("#txtCustomSlideSizeHeight").val(firstMasterLayout.height);
		}

		Storyboard.LayoutDesigner.showHideDocFormatSettingsByType();
	}

	function renderMasterLayoutThumbnails(layouts) {
		var layoutThumbnailsContainerEl = $('#divMasterLayoutSettingsWrapper .master-layouts').empty();
		var defaultMasterLayoutId = Number($("#divMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId").val());

		layouts.forEach(function(layout) {
			var isDefault = layout.layoutTemplateId === defaultMasterLayoutId;
			var layoutEl = $('<div class="master-layout'+ (isDefault ? ' default-layout' : '') +'" data-id="'+ layout.layoutTemplateId +'">'+
								'<div class="master-layout-thumbnail">'+
								'</div>'+
								'<div class="master-layout-name">'+ 
									layout.layoutTemplateName +
								'</div>'+
								(isDefault ? '<span class="badge badge-info">Default</span>' : '')+
							'</div>').appendTo(layoutThumbnailsContainerEl);

			layoutEl.find('.master-layout-thumbnail').append(ChartCreatorUI.renderSlideMasterLayoutThumbnail(layout));
		});
	}

	function onMasterLayoutThumbnailClick(event) {
		var masterLayoutEl = $(event.currentTarget);
		var layoutTemplateId = $(event.currentTarget).attr('data-id');
		var isDefault = masterLayoutEl.hasClass('default-layout');

		$('#masterLayoutDefaultMessage').hide();
		$('#divMasterLayoutSettingsWrapper .master-layouts .default-layout')
			.removeClass('default-layout')
			.find('.badge').remove();
		
		$("#divMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId").val(null);

		if (!isDefault) {
			masterLayoutEl
				.addClass('default-layout')
				.append('<span class="badge badge-info">Default</span>');

			$("#divMasterLayoutSettingsWrapper #hidDefaultMasterLayoutId").val(layoutTemplateId);
		}
	}

	// favorites and sharing
	function toggleSharing() {
		var favoritesEnabled = false;
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
			favoritesEnabled = $('#optCreateAndUpdate_cc').is(':checked');
		else
			favoritesEnabled = $('#chbFavorites_ct').is(':checked') || $('#chbWorkbooks_ct').is(':checked');

		var isPersonalEdition = window.IsPersonalEdition.toLowerCase() === 'true';
		$('#divSharingSetup').toggle(favoritesEnabled && !isPersonalEdition);

		toggleSharingOptions();
	}

	function onSharingTypeChanged() {
		var box = $(this);
		var msg;

		var itemType = 'Favorites';
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
			itemType = 'Decks';
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE && $('#chbWorkbooks_ct').is(':checked'))
			itemType = 'Workbooks';
		
		switch (box.attr('id')) {
			case 'chbShareWithAll':
				msg = 'The project contains {{items}} shared with all users, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [1], msg, itemType);
				break;
			case 'chbShareWithIndividual':
				msg = 'The project contains {{items}} shared with individual Report users, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [2, 4], msg, itemType, toggleSharingWithUsers);
				break;
			case 'chbShareWithGroup':
				msg = 'The project contains {{items}} shared with user groups, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [8, 16], msg, itemType, toggleSharingWithGroups);
				break;
			case 'chbShareWithAdmins':
				msg = 'The project contains {{items}} shared with individual Administrator, these {{items}} will become unshared.';
				checkIfNeedToUnshare(box, [32], msg, itemType);
				break;

			case 'optShareWithIndWithinGroup':
				msg = 'The project contains {{items}} shared with individual Report users, these {{items}} will become unshared.';
				checkIfNeedToAdjust(box, [4], msg, itemType);
				break;
			case 'optShareWithOwnGroup':
				msg = 'The project contains {{items}} shared with user groups, these {{items}} will become unshared.';
				checkIfNeedToAdjust(box, [16], msg, itemType);
				break;
		}
	}

	function checkIsCalcSelected() {
		var CTSettings = Storyboard.ChartLab.Setup.getCustomSettingsFromGui();

		return (CTSettings.calculationTypes != undefined && CTSettings.calculationTypes.length < 1 ? false : true)
	}
	function isAnyWeightChecked() {
		return $("#tblWeights tbody tr input:checked:enabled").length > 0;
	}
	function isAnyDateChecked() {
		return $("#tblDateVariables tbody tr input:checked:enabled").length > 0;
	}
	function checkIfNeedToUnshare(box, sharingTypes, message, itemType, callback) {
		message = message.replace(new RegExp('{{items}}', 'g'), itemType);

		if (!box.is(':checked') && sharingTypes && sharingTypes.length > 0) {
			var anyToUnshare = false;
			if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
				if ($('#chbFavorites_ct').is(':checked'))
					anyToUnshare = CrossTable2UIObj.HasRHFavoritesWithSharingTypes(sharingTypes);
				else if ($('#chbWorkbooks_ct').is(':checked'))
					anyToUnshare = CrossTable2UIObj.HasRHWorkbooksWithSharingTypes(sharingTypes);
			} else if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
				anyToUnshare = ChartCreatorUIObj.HasRHDecksWithSharingTypes(sharingTypes);

			if (anyToUnshare) {
				new DUIwindow2({
					closeButton: false,
					width: 340,
					height: 'auto',
					html: message,
					buttons: [{
							text: locale.get("Continue"),
							onClick: function () { if (callback) callback(); }
						}, {
							text: locale.get("Cancel"), focused: true,
							onClick: function () { $(box).attr('checked', 'checked'); }
						}]
				});
			} else if (callback) callback();

		} else if (callback) callback();
	}

	function checkIfNeedToAdjust(box, sharingTypes, itemType, message) {
		message = message.replace(new RegExp('{{items}}', 'g'), itemType);

		if (box.is(':checked') && sharingTypes && sharingTypes.length > 0) {
			var anyToAdjust = false;
			if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
				if ($('#chbFavorites_ct').is(':checked'))
					anyToAdjust = CrossTable2UIObj.HasRHFavoritesWithSharingTypes(sharingTypes);
				else if ($('#chbWorkbooks_ct').is(':checked'))
					anyToAdjust = CrossTable2UIObj.HasRHWorkbooksWithSharingTypes(sharingTypes);
			} else if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
				anyToAdjust = ChartCreatorUIObj.HasRHDecksWithSharingTypes(sharingTypes);

			if (anyToAdjust) {
				new DUIwindow2({
					closeButton: false,
					width: 340,
					height: 'auto',
					html: message,
					buttons: [{
						text: locale.get("Continue"), close: true
					}, {
						text: locale.get("Cancel"), focused: true,
						onClick: function () {
							var rbGroupName = $(box).attr('name');
							$('input[name="' + rbGroupName + '"]').removeAttr('checked');
							if (rbGroupName == 'opShareWithIndividual')
								$('#optShareWithAllInd').attr('checked', 'checked');
							else if (rbGroupName == 'opShareWithGroup')
								$('#optShareWithAllGroups').attr('checked', 'checked');
						}
					}]
				});
			}
		}
	}

	function toggleSharingOptions() {
		var favoritesEnabled = false;
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART)
			favoritesEnabled = $('#optCreateAndUpdate_cc').is(':checked');
		else
			favoritesEnabled = $('#chbFavorites_ct').is(':checked') || $('#chbWorkbooks_ct').is(':checked');

		var sharingEnabled = favoritesEnabled && $('#chbSharedFavorites').is(':checked');
		$('.favoritesSharingSettings').toggle(sharingEnabled);
		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
			$('.wbOnly').toggle(sharingEnabled && $('#chbWorkbooks_ct').is(':checked'));
			if ($('#chbWorkbooks_ct').is(':checked'))
				$('#chbShareWithGroup').closest('.size-1-3').removeClass('size-last');
			else if ($('#chbFavorites_ct').is(':checked'))
				$('#chbShareWithGroup').closest('.size-1-3').addClass('size-last');
		}
		
		$('#chbShareWithGroup').closest('div').toggle(ProjectHasUserGroups);

		toggleSharingWithUsers();
		toggleSharingWithGroups();
	}

	function toggleSharingWithUsers() {
		var userSharingEnabled = $('#chbShareWithIndividual').is(':checked');
		$('#optShareWithIndWithinGroup, #optShareWithAllInd').closest('span').toggle(userSharingEnabled && ProjectHasUserGroups);

		if (!userSharingEnabled) {
			$('#optShareWithIndWithinGroup, #optShareWithAllInd').removeAttr('checked');
		} else if (!ProjectHasUserGroups)
			$('#optShareWithAllInd').attr('checked', true);
		else if ($('#optShareWithIndWithinGroup:checked, #optShareWithAllInd:checked').length == 0)
			$('#optShareWithIndWithinGroup').attr('checked', true);
	}

	function toggleSharingWithGroups() {
		var groupSharingEnabled = ProjectHasUserGroups && $('#chbShareWithGroup').is(':checked');
		$('#optShareWithOwnGroup, #optShareWithAllGroups').closest('span').toggle(groupSharingEnabled);
		if (!groupSharingEnabled) {
			$('#optShareWithOwnGroup, #optShareWithAllGroups').removeAttr('checked');
		} else if ($('#optShareWithOwnGroup:checked, #optShareWithAllGroups:checked').length == 0)
			$('#optShareWithOwnGroup').attr('checked', true);
	}

    return {
        Setup: {
            settings: settings,
            optionalSettings: optionalSettings,
            createPart: createPart,
            load: load,
            save: save,
            check: check,
            loadSettings: loadSettings,
            disabledOrEnableAllParts: disabledOrEnableAllParts,
            checkSetupIntervalID: checkSetupIntervalID,
            loadCustomSettings: loadCustomSettings,
            setOptionalSettings: setOptionalSettings,
            setOptionalSettingsForCT: setOptionalSettingsForCT,
            closeCustomSettings: closeCustomSettings,
            saveCustomSettings: saveCustomSettings,
            getCustomSettingsFromGui: getCustomSettingsFromGui,
            setupOptionalChartSettings: setupOptionalChartSettings,
			setOptionalChartSettingsForPart: setOptionalChartSettingsForPart,
			createCategoriesTable: createCategoriesTable,
			addStaticFilterRow: addStaticFilterRow,
			loadStaticFilterAnswers: loadStaticFilterAnswers,
			bindEvents: bindEvents
        }
    };
}());
